import React, { useState, useEffect, useRef, useMemo } from "react";
import { Button } from "../../Components/UI/button";
import { Input } from "../../Components/UI/input";
import { Badge } from "../../Components/UI/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow, } from "../../Components/UI/table";
import { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger } from "../../Components/UI/tooltip";
import { Plus, Search, Filter, ArrowUp, ArrowDown, Loader2, UserIcon, CalendarIcon, ArrowDownWideNarrow, ClockFadingIcon, ChevronsUpDown, Check, UserCircle, Trash2, Download, Paperclip, ArrowLeft, ArrowLeftRightIcon, UserCheck, MessageSquare, History, Star } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardContent } from "../../Components/UI/card";
import { getActiveThreadTypesArr, getThreadTypeByTID, getThreadTypesArr, getUsersArr, isSmartSellerMode, updateHeaderConfig } from "../../Store/Reducers";
import { getTableDateOrWeekday } from "../../Utils/DateTime";
import PaginationComp from "../../Components/Common/Pagination";
import ThreadEntry from "./ThreadEntry";
import { checkUserRights, currentUserHasPermission, FormatAmount, formatAmount, getColorClass, getDateRangeOptions, getLastDateColor, getOtherMonthOptions, getOtherQuarterOptions, getOtherYearOptions, getPastMonthOptions, getPastQuarterOptions, getTaskColor, getThreadTypeMeta, isSalesOnlyActive, timeAgo, toAllWordsLowerCase } from "../../Utils/Utilities";
import ContactActions from "../../Components/Common/ContactActions";
import { CommonFilter } from "../../Components/Common/CommonFilter";
import { cn } from "../../Lib/Cn";
import { addDays, format } from 'date-fns';
import { Drawer, DrawerClose, DrawerContent, DrawerFooter } from "../../Components/UI/drawer";
import DrawerFilter from "../../Components/Common/DrawerFilter";
import { DatePicker } from "../../Components/Common/DatePicker";
import { RiResetLeftFill } from "react-icons/ri";
import Integrations from "./Integrations";
import useIsMobile from "../../Hooks/useIsMobile";
import { useModalBackButton } from "../../Hooks/useModalBackButton";
import { FaExpandAlt } from "react-icons/fa";
import { BsViewStacked, BsWhatsapp } from "react-icons/bs";
import { LuCalendarClock } from "react-icons/lu";
import { MdPhone } from "react-icons/md";
import { useVirtualizer } from "@tanstack/react-virtual";
import { useCurrency } from "../../Hooks/useCurrency";
import ThreadDropdown from "./AddThreadDropdown";
import ThreadSahiIcon from "../../Components/Common/ThreadSahiIcon";
import { Checkbox } from "../../Components/UI/checkbox";
import { bulkThreadActionAPI, getThreadsAPI } from "./ThreadsAPI";
import { Popover, PopoverContent, PopoverTrigger } from "../../Components/UI/popover";
import { checkAPIResponse } from "../../Utils/APIResponseUtils";
import { setGlobalLoading } from "../../Store/Actions";
import ThrDetails from "./ThrDetails";
import { getAgencyData, getConfigData } from "../../Utils/Storage";
import ImportThreadsExcel from "./ImportThreadsExcel";
import { toast } from 'sonner';
import { SHOW_IMPORT_INQUIRIES, canShowImportInquiries } from "../../Utils/FeatureFlags";
import { AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter } from '../../Components/UI/alert-dialog';
import { X } from "lucide-react";
import { getThreadTypeName } from "../../Utils/Utilities";
import { userIsAdmin, checkIfInqOnlyMode, isAgencyAllowed } from "../../Store/Reducers";
import { getAuthData } from "../../Utils/AuthUtils";
import { FaCircle, FaDownload } from "react-icons/fa6";
import { isThrStgExpird } from "../../Utils/Utilities";
import ReassignDialog from "./ReassignDialog";
import ColumnPreferencesDropdown from "../../Components/Common/ColumnPrefereceDD";
import ConnectionDetails from "../Connections/ConnectionDetails";
import ConnectionDetailsMobile from "../Connections/ConnectionDetailsMobile";
import { handlePhoneClickAction, handleWhatsAppClickAction } from "../../Utils/ContactLogUtils";
import { useDesktop } from "../../Components/Common/IsDesktop";
import BulkWhatsAppDialog from "../Configs/WhatsAppDirectConfig/BulkWhatsAppDialog";
import { toggleThreadStarAPI } from "./ThreadsAPI";
import TemplateDialog from "../../Components/Common/TemplateDialog";

const stageExpiryFilter = [
  { term: "All Threads", code: "all", inquiryTerm: "All Inquiries" },
  { term: "Stuck at stage", code: "expired", inquiryTerm: "Stuck at stage" },
  { term: "Not stuck at stage", code: "notExpired", inquiryTerm: "Not stuck at stage" },
];

const receivedOnFilter = [
  { term: "Today", code: 0 },
  { term: "Yesterday", code: 1 },
  { term: "Last 7 days", code: 2 },
  { term: "Last month", code: 3 },
];

const dueOnFilter = [
  { term: "Overdue", code: 0 },
  { term: "Yesterday", code: 1 },
  { term: "Today", code: 2 },
  { term: "Tomorrow", code: 3 },
  { term: "This week", code: 4 },
  { term: "Next 7 days", code: 5 },
];

const nextTaskFilter = [
  { term: "Not set", code: 0 },
  { term: "Overdue", code: 1 },
  { term: "Yesterday", code: 2 },
  { term: "Today", code: 3 },
  { term: "Next 7 days", code: 4 },
  { term: "Next 30 days", code: 5 },
];

const sortKeyMap = {
  bizName: "connectionData.bizName", // Match this to your sortData logic just for name not value.
  status: "currStageID",
};

const sidebarIcons = [
  { key: "connID", icon: UserCircle },
  { key: "stage", icon: BsViewStacked },
  { key: "assignedTo", icon: UserIcon },
  { key: "sort", icon: ArrowDownWideNarrow },
];

const sortKeyMapMobileFilter = {
  "Due (oldest first)": { key: "dueDT", direction: "asc", },
  "Received (newest first)": { key: "sinceDT", direction: "desc", },
  "Next action (oldest first)": { key: "nextTaskDT", direction: "asc", },
  "Received (oldest first)": { key: "sinceDT", direction: "asc", },
  "Amount (highest first)": { key: "bizProspect", direction: "desc", },
}

//Local CSS Classes
let checkBoxCss = "data-[state=checked]:bg-sahi-primary-color data-[state=checked]:border-sahi-primary-color data-[state=checked]:text-white transition-colors"
var filterBtn = "button-config sahi-primary-button flex items-center justify-center group px-2.5 py-[5px]";
let actionButton = "action-btn-effect hover:bg-sahi-blue-light";

const Threads = ({ initialTID = null, embedded = false, activeTab: parentActiveTab = "", searchTerm: externalSearchTerm = "", onFilterStateChange, onCountChange }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const isDesktop = useDesktop();
  const clickedTabRef = useRef(null);
  const parentRef = useRef(null);
  const dispatch = useDispatch()
  //Query Params
  const searchParams = new URLSearchParams(location.search);
  const parsedTID = parseInt(searchParams.get("tid"), 10);
  const tID = embedded && initialTID !== null ? initialTID : (!isNaN(parsedTID) ? parsedTID : (initialTID !== null ? initialTID : NaN));
  const threadModeType = searchParams.get("m");
  const starParam = searchParams.get("star");

  // Store initial starParam in a ref so it doesn't get lost if URL changes
  const initialStarParamRef = useRef(null);
  if (initialStarParamRef.current === null && starParam) {
    initialStarParamRef.current = starParam;
  }

  // Use the ref value if the URL param is lost
  const effectiveStarParam = starParam || initialStarParamRef.current;
  const [paramConnID, setParamConnID] = useState('')
  const [paramStage, setParamStage] = useState('')

  useEffect(() => {
    if (embedded && typeof externalSearchTerm === "string") {
      setSearchTerm(externalSearchTerm);
    }
  }, [embedded, externalSearchTerm]);

  useEffect(() => {
    if (!embedded) return;
    const handleToggle = () => {
      setIsFilterSelected(true);
      setIsDrawerOpen(true);
    };
    const eventName = initialTID === 2 ? "sales-toggle-filter" : "inquiries-toggle-filter";
    window.addEventListener(eventName, handleToggle);
    return () => {
      window.removeEventListener(eventName, handleToggle);
    };
  }, [embedded, initialTID]);

  useEffect(() => {
    if (!embedded) return;
    const handleOpenImport = () => {
      setIntegrationsOpen(true);
    };
    window.addEventListener("inquiries-open-import", handleOpenImport);
    return () => {
      window.removeEventListener("inquiries-open-import", handleOpenImport);
    };
  }, [embedded]);
  let { data: threadData, loading, error } = useSelector((state) => state.threadData);
  const { data: connectionData } = useSelector((state) => state.connectionData);
  const activeData = useSelector((state) => state.activeData);
  const [isLoading, setIsLoading] = useState(true);
  const users = useSelector(getUsersArr);
  const isAdmin = useSelector(userIsAdmin);
  const isAgencyAuthorized = useSelector(isAgencyAllowed);
  const thrColPrefs = useSelector(state => state.masterData.thrColPrefs || []);
  const threadTypes = useSelector(getActiveThreadTypesArr);

  const columnDfltVisibilityObj = {
    type: true,
    bizName: true,
    contactName: true,
    mainProduct: true,
    bizProspect: true,
    sinceDT: true,
    dueDT: true,
    reference: true,
    status: true,
    nextTaskDT: true,
    pocUserName: true,
    source: false,
    mobile: false,
    email: false,
    city: false,
    lastInteraction: false
  };

  const getColumnVisibilityFromPrefs = (prefs) => {
    if (!prefs || (Array.isArray(prefs) && prefs.length === 0)) return { ...columnDfltVisibilityObj };
    const prefsData = Array.isArray(prefs) ? prefs[0] : prefs;
    let parsed = typeof prefsData === 'string' ? JSON.parse(prefsData) : prefsData;
    if (Array.isArray(parsed)) parsed = parsed[0];
    return {
      type: parsed.Type ?? true,
      bizName: parsed.BizName ?? true,
      contactName: parsed.ContactName ?? true,
      mainProduct: parsed.Product ?? true,
      bizProspect: parsed.Amount ?? true,
      sinceDT: parsed.Received ?? true,
      dueDT: parsed.Due ?? true,
      reference: parsed.Ref ?? true,
      status: parsed.Status ?? true,
      nextTaskDT: parsed.NextTask ?? true,
      pocUserName: parsed.Executive ?? true,
      source: parsed.Source ?? false,
      mobile: parsed.Mobile ?? false,
      email: parsed.Email ?? false,
      city: parsed.City ?? false,
      lastInteraction: parsed.LastInteraction ?? false
    };
  };

  const [columnVisibility, setColumnVisibility] = useState(() => {
    if (isAdmin) {
      return getColumnVisibilityFromPrefs(thrColPrefs);
    } else {
      const storedPrefs = localStorage.getItem("ThrColPrefs");
      if (storedPrefs) {
        try {
          return JSON.parse(storedPrefs);
        } catch (error) {
          console.error("Error parsing ThrColPrefs from localStorage:", error);
        }
      }
      // User Fallback: If no localStorage, load from Redux (masterData)
      if (thrColPrefs && (Array.isArray(thrColPrefs) ? thrColPrefs.length > 0 : thrColPrefs)) {
        return getColumnVisibilityFromPrefs(thrColPrefs);
      }
    }
    return { ...columnDfltVisibilityObj };
  });

  // Sync state if Redux prefs change (Primary for Admin, secondary for User fallback)
  useEffect(() => {
    const storedPrefs = localStorage.getItem("ThrColPrefs");

    // Only sync from Redux if:
    // 1. User is Admin
    // 2. User is NOT Admin AND has no local storage preference (using Redux as fallback)
    if (isAdmin || (!isAdmin && !storedPrefs)) {
      if (thrColPrefs) {
        const newVisibility = getColumnVisibilityFromPrefs(thrColPrefs);
        const currentStr = JSON.stringify(columnVisibility);
        const newStr = JSON.stringify(newVisibility);

        if (currentStr !== newStr) {
          setColumnVisibility(newVisibility);
        }
      }
    }
  }, [thrColPrefs, isAdmin]);

  // Sync across tabs for regular users
  useEffect(() => {
    if (!isAdmin) {
      const handleStorageChange = (e) => {
        if (e.key === 'ThrColPrefs' && e.newValue) {
          try {
            setColumnVisibility(JSON.parse(e.newValue));
          } catch (error) {
            console.error("Error parsing ThrColPrefs from storage event:", error);
          }
        }
      };

      const checkLocalStorage = () => {
        const storedPrefs = localStorage.getItem("ThrColPrefs");
        if (storedPrefs) {
          try {
            const parsed = JSON.parse(storedPrefs);
            if (JSON.stringify(columnVisibility) !== JSON.stringify(parsed)) {
              setColumnVisibility(parsed);
            }
          } catch (error) {
            console.error("Error parsing ThrColPrefs on focus:", error);
          }
        }
      };

      window.addEventListener('storage', handleStorageChange);
      window.addEventListener('focus', checkLocalStorage);
      return () => {
        window.removeEventListener('storage', handleStorageChange);
        window.removeEventListener('focus', checkLocalStorage);
      };
    }
  }, [isAdmin, columnVisibility]);
  const threadType = useSelector(getThreadTypeByTID(tID));
  const getAllThreadTypesString = () => {
    return threadTypes.map(t => t.TID).join('');
  };

  const [threadTypeInfo, setThreadTypeInfo] = useState({}); // Default to Inquiry initially
  const [threads, setThreads] = useState([]);
  const [threadTypeCnt, setThreadTypeCnt] = useState({});
  const [filteredThreads, setFilteredThreads] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [threadEntryOpen, setThreadEntryOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("sort");
  const [open, setOpen] = useState(false);
  const [preSearchThreads, setPreSearchThreads] = useState([]); // filtered by filters only
  const [selectedThread, setSelectedThread] = useState({});
  const [orderImportOpen, setOrderImportOpen] = useState(false);
  const [integrationsOpen, setIntegrationsOpen] = useState(false);
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [activeConnection, setActiveConnection] = useState(null);
  const [isThreadDetialsOpen, setIsThreadDetailsOpen] = useState(false);
  const [isConnDetailOpen, setIsConnDetailOpen] = useState(false);
  const [isMobileConnDetailpOpen, setIsMobileConnDetailOpen] = useState(false);
  const [selectedConnID, setSelectedConnID] = useState(0);
  const [pendingThreadId, setPendingThreadId] = useState(null);
  const totalThreadCnt = Object.values(threadTypeCnt).reduce((acc, val) => acc + val, 0);
  const prevFiltersRef = useRef({});
  const [selectedThreadTypeFromDropdown, setSelectedThreadTypeFromDropdown] = useState(null);
  const [hideTypeColumn, setHideTypeColumn] = useState(false);
  const currencySymbol = useCurrency();
  const [connData, setConndata] = useState([])
  const [sourceThreads, setSourceThreads] = useState([]);
  const [reassignDialogOpen, setReassignDialogOpen] = useState(false);
  const [bulkWhatsAppDialogOpen, setBulkWhatsAppDialogOpen] = useState(false);
  const [selectAllCurrentPage, setSelectAllCurrentPage] = useState(false);
  const [isMobileContactActionsOpen, setIsMobileContactActionsOpen] = useState(false);
  const [isThrIdFromParams, setIsThrIdFromParams] = useState(false);

  const handleThreadTypeSelect = (threadTypeID) => {
    setSelectedThreadTypeFromDropdown(threadTypeID);
    setThreadEntryOpen(true);
  };
  const [modeValue, setModeValue] = useState("Open"); // default
  const [threadDeleteBulkIDs, setThreadDeleteBulkIDs] = useState([]);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);
  const loginUserData = getAuthData();
  const thrActions = currentUserHasPermission('ThrActions');
  const userRights = checkUserRights();
  const isInqOnlyMode = useSelector(checkIfInqOnlyMode);
  const threadStages = useSelector(
    (state) => state.masterData?.threadStages || []
  );
  // useful for sorting and filter
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [isFilterSelected, setIsFilterSelected] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(() => ({
    stage: "all",
    assignedTo: "all",
    receivedOn: "all",
    dueOn: "all",
    nextTaskOn: "all",
    types: tID && Number(tID) !== 0 ? String(tID) : (threadTypes && threadTypes.length > 0 ? threadTypes.map(t => t.TID).join('') : "1"),
    connID: "all",
    dateRange: "all",
    finYear: "all",
    otherMonth: "all",
    otherQuarter: "all",
    otherYear: "all",
    fromDate: null,
    toDate: null,
    connType: "all",
    category: "all",
    stageExpiry: false,
    starOnly: false,
  }));
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [tempFilters, setTempFilters] = useState(selectedFilters);
  const [tempsortConfig, setTempsortConfig] = useState(sortConfig);
  const [stageInfo, setStageInfo] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([]);
  const longPressTimerRef = useRef(null);
  const [isLongPress, setIsLongPress] = useState(false);
  const [isBulkAllowed, setIsBulkAllowed] = useState(false);

  // Check if any filter is applied (not default value)
  const hasActiveFilters = Object.entries(selectedFilters).some(([key, value]) => {
    // Skip 'types' field or adjust this logic based on your needs
    if (key === 'types') return isInqOnlyMode ? value != "1" : value !== "123456";
    if (key === 'stageExpiry') return value === true;
    if (key === 'starOnly') return value === true;
    return value !== "all";
  });

  useEffect(() => {
    if (embedded && onFilterStateChange) {
      onFilterStateChange(Boolean(hasActiveFilters));
    }
  }, [embedded, hasActiveFilters, onFilterStateChange]);

  // Extract unique categories from threads
  const getUniqueCategoriesFromThreads = (threadsList) => {
    const categories = new Set();
    threadsList.forEach(thread => {
      const category = thread.connectionData?.category;
      if (category && category.trim() !== "") {
        categories.add(category);
      }
    });
    return Array.from(categories).sort();
  };

  //functions to get date range filters options

  //Threads table header Obj
  const threadTableHeadersData = [
    { key: "type", label: "", className: "align-middle text-text-color w-[1vw]" },
    ...(isInqOnlyMode ? [{ key: "checkbox_col", label: "", className: "align-middle text-text-color w-[1vw]" }] : []),
    { key: "bizName", label: "Business", className: "align-middle text-text-color truncate" },
    { key: "mobile", label: "Mobile", className: "align-middle" }, // Moved to top place after Business
    { key: "contactName", label: "Contact", className: "align-middle text-text-color" },
    { key: "mainProduct", label: "Offering", className: "align-middle text-text-color min-w-[90px]" },
    {
      key: "bizProspect",
      label: <label className="text-sm font-medium text-gray-900 whitespace-nowrap">
        Amount (
        <span className="whitespace-nowrap text-gray-500 text-base">
          {currencySymbol}
        </span>
        )
      </label>
      ,
      className: "flex justify-end items-start text-right align-middle"
    },
    { key: "sinceDT", label: "Received on", className: "align-middle" },
    { key: "dueDT", label: "Expected by", className: "align-middle" },
    { key: "reference", label: "Reference", className: "align-middle" },
    { key: "status", label: "Status", className: "align-middle" },
    { key: "nextTaskDT", label: "Next Action", className: "align-middle text-start break-words whitespace-normal" },
    { key: "pocUserName", label: "Executive", className: "align-middle" },
    { key: "source", label: "Source", className: "align-middle" },
    { key: "email", label: "Email", className: "align-middle" },
    { key: "city", label: "City", className: "align-middle" },
    ...(isAgencyAuthorized ? [{ key: "lastInteraction", label: "Last Interaction", className: "align-middle" }] : [])
  ];

  const convertedTIDs = tempFilters.types
    ? tempFilters.types.toString().split("").map(tid => parseInt(tid, 10))
    : [];

  const oldestSinceDT = useMemo(() => {
    const dates = [];

    if (connectionData && connectionData.length > 0) {
      connectionData.forEach((conn) => {
        const dateStr = conn.SinceDT || conn.CreatedDT;
        if (dateStr) {
          const d = new Date(dateStr);
          if (!isNaN(d.getTime())) dates.push(d);
        }
      });
    }

    if (threadData && threadData.length > 0) {
      threadData.forEach((thr) => {
        const dateStr = thr.sinceDT || thr.createdDT || thr.dueDT || thr.SinceDT || thr.CreatedDT;
        if (dateStr) {
          const d = new Date(dateStr);
          if (!isNaN(d.getTime())) dates.push(d);
        }
      });
    }

    const raw = activeData?.data?.MonthlyThreads || activeData?.MonthlyThreads;
    let monthlyJson = [];
    if (typeof raw === 'string') {
      try { monthlyJson = JSON.parse(raw); } catch (e) { monthlyJson = []; }
    } else if (Array.isArray(raw)) {
      monthlyJson = raw;
    }
    if (Array.isArray(monthlyJson)) {
      monthlyJson.forEach((item) => {
        if (item.YY && item.MM) {
          const d = new Date(Number(item.YY), Number(item.MM) - 1, 1);
          if (!isNaN(d.getTime())) dates.push(d);
        }
      });
    }

    if (dates.length === 0) return new Date();

    return new Date(Math.min(...dates));
  }, [connectionData, threadData, activeData]);

  const filterOptions = [
    {
      key: "types",
      label: "All Thread Types",
      options: threadTypes.map((t) => ({ name: t.Typ, ID: t.TID.toString() })),
      type: "options",
      mobileDropdownText: "Select Thread Type",
      MobileLabel: "Thread Type",
      showAllOptionNum: true
    },
    {
      key: "connID",
      label: "All Contacts",
      options: connData.map((c) => ({ name: c.bizName || c.contactName, ID: c.connID })),
      displayValue: (val) => {
        let displayText = 'All Contacts';
        let bizName = connData.find(c => Number(c.connID) === Number(val))?.bizName
        if (bizName == '') {
          displayText = connData.find(c => Number(c.connID) === Number(val))?.contactName || ''
        }
        else {
          displayText = bizName;
        }
        return displayText;
      },
      type: "list",
      mobileDropdownText: "Select Contact",
      MobileLabel: "Contact",
      showAllOption: true
    },
    ...(!isSmartSellerMode() ? [{
      key: "assignedTo", label: "All Executives",
      options: [{ name: "Not Assigned", ID: "unassigned" }, ...users.map((u) => ({ name: u.name, ID: u.userID })),].sort((a, b) => {
        if (a.name === "Not Assigned") return -1;
        if (b.name === "Not Assigned") return 1;
        return a.name.localeCompare(b.name);
      }),
      displayValue: (val) => { if (val === "unassigned") return "Not Assigned"; return users.find((u) => u.userID === val)?.name; },
      type: "list",
      mobileDropdownText: "Select Executive",
      MobileLabel: "Executive",
      showAllOption: true
    }] : []),

    {
      key: "stage",
      label: "All Stages",
      options:
        stageInfo.find(type => type.TID === convertedTIDs[0])?.Stages.map(stage => ({
          name: stage.S,
          ID: stage.SID
        })) || [],
      displayValue: (val) => {
        return stageInfo
          .find(type => type.TID === convertedTIDs[0])
          ?.Stages.find(stage => stage.SID === val)?.S || val
      },
      mobiledisabled: tempFilters.types.length !== 1,
      type: "options",
      searchEnabled: false,
      disabled: selectedFilters.types.length !== 1,
      MobileLabel: "Stage",
      showAllOption: true
    },
    {
      key: "category",
      label: "All Categories",
      options: availableCategories.map((cat) => ({ name: cat, ID: cat })),
      displayValue: (val) => {
        if (val === "all") return "All Categories";
        return val;
      },
      type: "list",
      searchEnabled: true,
      mobileDropdownText: "Select Category",
      MobileLabel: "Category",
      showAllOption: true
    },
    {
      key: "connType",
      label: "Connection Type",
      options: [
        { name: "Prospects", ID: "P" },
        { name: "Customers", ID: "C" }
      ],
      displayValue: (val) => {
        if (val === "all") return "All";
        if (val === "P") return "Future Prospects";
        if (val === "C") return "Existing Customers";
        if (val === "") return "None Selected";
        return "Select Type";
      },
      type: "options", // Change to multi-select if you have that type
      searchEnabled: false,
      MobileLabel: "Connection Type",
      showAllOption: true, // Remove the "All" option
      disabled: selectedFilters.types !== "1",
      mobiledisabled: tempFilters.types !== "1",
    },
    {
      key: "dateRange",
      label: "All Time",
      options: getDateRangeOptions().map(option => ({
        name: option,
        ID: option,
      })),
      searchEnabled: false,
      type: "list",
      MobileLabel: "Period",
      showAllOption: false,
      displayValue: (val) => val || "All Time"
    },
    {
      key: "otherMonth",
      label: "Select Month",
      options: (() => {
        const generated = getPastMonthOptions(oldestSinceDT);
        const current = selectedFilters.otherMonth;
        if (current !== "all" && !generated.some(opt => opt.ID === current)) {
          generated.unshift({ name: current, ID: current });
        }
        return generated;
      })(),
      disabled: !(selectedFilters.dateRange === "Other Month" || tempFilters.dateRange === "Other Month"),
      mobiledisabled: !(tempFilters.dateRange === "Other Month"),
      type: "list",
      mobileDropdownText: "Month",
      mobileNoLabel: false,
      sortDescending: true,
      isSorting: false
    },
    {
      key: "otherQuarter",
      label: "Select Quarter",
      options: (() => {
        const generated = getPastQuarterOptions(oldestSinceDT);
        const current = selectedFilters.otherQuarter;
        if (current !== "all" && !generated.some(opt => opt.ID === current)) {
          generated.unshift({ name: current, ID: current });
        }
        return generated;
      })(),
      disabled: !(selectedFilters.dateRange === "Other Quarter" || tempFilters.dateRange === "Other Quarter"),
      mobiledisabled: !(tempFilters.dateRange === "Other Quarter"),
      type: "list",
      mobileDropdownText: "Quarter",
      mobileNoLabel: false,
      sortDescending: true,
      isSorting: false
    },
    {
      key: "otherYear",
      label: "Select Year",
      options: (() => {
        const generated = getOtherYearOptions(oldestSinceDT);
        const current = selectedFilters.otherYear;
        if (current !== "all" && !generated.some(opt => opt.ID === current)) {
          generated.unshift({ name: current, ID: current });
        }
        return generated;
      })(),
      disabled: !(selectedFilters.dateRange === "Other Year" || tempFilters.dateRange === "Other Year"),
      mobiledisabled: !(tempFilters.dateRange === "Other Year"),
      type: "list",
      mobileDropdownText: "Year",
      mobileNoLabel: false,
      sortDescending: true,
      isSorting: false
    },
    // {
    //   key: "receivedOn",
    //   label: "Received on",
    //   options: receivedOnFilter.map(item => item.term),
    //   type: "options",
    //   searchEnabled: false
    // },
    // {
    //   key: "dueOn",
    //   label: "Due on",
    //   options: dueOnFilter.map(item => item.term),
    //   type: "options",
    //   searchEnabled: false
    // },
    // {
    //   key: "nextTaskOn",
    //   label: "Next Action on",
    //   options: nextTaskFilter.map(item => item.term),
    //   type: "options",
    //   searchEnabled: false,
    //   disabled: modeValue === "Processed",
    // },
  ]

  // mobile filters icon click button
  const handleFilterIconClick = (key) => {
    setActiveTab(key);
    clickedTabRef.current = true;
    setTimeout(() => {
      clickedTabRef.current = false;
    }, 500); // prevent scroll override for 500ms
    const el = document.getElementById(key);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };


  // Handle toggle star for a thread
  const handleToggleStar = async (thread, event) => {
    event?.stopPropagation();
    const newStarStatus = !thread.isStar;

    setThreads(threads.map(t =>
      t.threadID === thread.threadID
        ? { ...t, isStar: newStarStatus }
        : t
    ));

    try {
      await toggleThreadStarAPI(thread, newStarStatus);
      toast.success(newStarStatus ? `${isInqOnlyMode ? "Inquiry marked as important" : "Thread marked as important"}` : `${isInqOnlyMode ? "Inquiry unmarked as important" : "Thread unmarked as important"}`);
    } catch (error) {
      setThreads(threads.map(t =>
        t.threadID === thread.threadID
          ? { ...t, isStar: !newStarStatus }
          : t
      ));
      console.error('Error toggling star:', error);
      toast.error('Failed to update star status');
    }
  };

  // Handle thread actions
  const handleThreadAction = (action, thread, event) => {
    event?.stopPropagation();
    switch (action) {
      case "DOWNLOAD":
        if (thread.thrFile) {
          const fileUrl = `/Uploads/${thread.thrFile}`;
          window.open(fileUrl, "_blank");
        }
        break;
      default:
        break;
    }
  };

  // Filter headers based on hideTypeColumn state
  const getFilteredHeaders = () => {
    const isOnlyInquiry = threadTypeInfo.typeID == 1;

    return threadTableHeadersData.filter(header => {
      if (header.key !== 'checkbox_col' && columnVisibility[header.key] === false) return false;
      if (modeValue === 'Processed' && header.key === 'nextTaskDT') return false;
      if (hideTypeColumn && header.key === 'type') return false;
      if (isOnlyInquiry && header.key == 'reference') return false;
      return true;
    });
  };

  // Handle import dialog navigation from dashboard
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const openImport = params.get('openImport');

    if (openImport === 'true' && userRights?.addThr) {
      // Open integrations dialog
      setIntegrationsOpen(true);

      // Clean up URL parameter
      params.delete('openImport');
      const newSearch = params.toString();
      navigate(
        `${location.pathname}${newSearch ? `?${newSearch}` : ''}`,
        { replace: true }
      );
    }
  }, [location.search, navigate, userRights?.addThr]);

  //Mobile Filter Scrollbar Event Listener
  useEffect(() => {
    const waitAndAttachScroll = () => {
      const container = document.querySelector(".filter-scroll-container");

      if (!container) {
        setTimeout(waitAndAttachScroll, 50);
        return;
      }

      const handleScroll = () => {
        if (clickedTabRef.current) return;

        const scrollTop = container.scrollTop;
        const scrollHeight = container.scrollHeight;
        const clientHeight = container.clientHeight;
        const scrollPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;
        const index = Math.min(
          Math.floor((scrollPercent / 100) * sidebarIcons.length),
          sidebarIcons.length - 1
        );
        const key = sidebarIcons[index]?.key;
        setActiveTab((prev) => (key !== prev ? key : prev));
      };
      container.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => container.removeEventListener("scroll", handleScroll);
    };

    waitAndAttachScroll();
  }, [isFilterSelected]);

  useEffect(() => {
    // Reset all isChecked values to false when thread types filter changes
    setThreads(prevThreads =>
      prevThreads.map(thread => ({ ...thread, isChecked: false }))
    );

    setFilteredThreads(prevFilteredThreads =>
      prevFilteredThreads.map(thread => ({ ...thread, isChecked: false }))
    );

    // Clear the bulk delete IDs
    setThreadDeleteBulkIDs([]);
  }, [selectedFilters.types]);

  useEffect(() => {
    if (selectedFilters.types !== "1" && selectedFilters.connType !== "all") {
      setSelectedFilters(prev => ({
        ...prev,
        connType: "all"
      }));
      setTempFilters(prev => ({
        ...prev,
        connType: "all"
      }));
    }
  }, [selectedFilters.types]);

  useEffect(() => {
    if (isFilterSelected && isMobile) {
      setIsDrawerOpen(true);
      setTempFilters(selectedFilters);
      // setTempsortConfig(sortConfig);
    }
  }, [isFilterSelected, isMobile, threadTypeInfo.typeID]);

  const getExecutiveName = (userID) => {
    if (!userID) return "-";
    const user = users.find((user) => user.userID === Number(userID));
    return user ? user.name : "-";
  }

  useEffect(() => {
    const configData = getConfigData();
    const threadStages = JSON.parse(configData.ThreadStages) || []
    setStageInfo(threadStages)
  }, [])

  const getStageInfo = (typeID, stageID) => {
    const thread = stageInfo.find(thread => thread.TID === typeID);
    if (!thread) return null;
    const stage = thread.Stages.find(stage => stage.SID === stageID);
    if (!stage) return null;
    return { SID: stage.SID, name: stage.S };
  };

  // Utils for safe parsing
  const safeParseArray = (input, fallback = []) => {
    if (Array.isArray(input)) return input;
    try {
      return JSON.parse(input || "[]");
    } catch {
      return fallback;
    }
  };

  // Update selected thread when threads change
  useEffect(() => {
    if (selectedThread) {
      // Find the updated thread from the threads list
      const updatedThread = threads.find(thread => thread.threadID === selectedThread.threadID);
      if (updatedThread) {
        setSelectedThread(updatedThread);
      }
    }
  }, [threads])

  const handleRowClick = (thread) => {
    setSelectedThread(thread);
    if (isInqOnlyMode) {
      setSelectedConnID(thread?.connID);
      if (isMobile) {
        setIsMobileConnDetailOpen(true);
        setIsConnDetailOpen(false);
        return;
      }
      setIsMobileConnDetailOpen(false);
      setIsConnDetailOpen(true);
    }
    else {
      setIsThreadDetailsOpen(true);
    }
  };

  const handleTouchStart = (threadID) => {
    // Reset previous timer if any
    if (longPressTimerRef.current) clearTimeout(longPressTimerRef.current);

    setIsLongPress(false); // Reset status

    // Start a timer for 500ms
    longPressTimerRef.current = setTimeout(() => {
      setIsLongPress(true);
      // Trigger selection on long press
      handleCheckboxChange(threadID, true);
      // Optional: Vibrating feedback
      if (navigator.vibrate) navigator.vibrate(50);
    }, 1200);
  };

  const handleTouchEnd = () => {
    if (longPressTimerRef.current) clearTimeout(longPressTimerRef.current);
  };

  const handleMobileCardClick = (thread) => {
    if (isLongPress) return;

    const isSelectionMode = threadDeleteBulkIDs.length > 0;

    if (isSelectionMode) {
      handleCheckboxChange(thread.threadID, !thread.isChecked);
    } else {
      handleRowClick(thread);
    }
  };

  // Intercept Hardware/Browser Back button when rows are selected in bulk mode on mobile
  useModalBackButton(
    isMobile && threadDeleteBulkIDs.length > 0,
    (open) => {
      if (!open) {
        handleClearSelection();
      }
    },
    "threads-selection"
  );

  useEffect(() => {
    if (!isMobile) return;

    const selectedCount = threadDeleteBulkIDs.length;

    if (selectedCount > 0) {
      dispatch(updateHeaderConfig({
        title: `${selectedCount} Selected`,
        iconLeft: {
          icon: ArrowLeft,
          // When clicking UI Back button, clear selection directly
          onClick: () => {
            handleClearSelection();
          },
        },
        actionsRight: [
          {
            icon: BsWhatsapp,
            onClick: () => {
              setBulkWhatsAppDialogOpen(true);
            }
          }
        ]
      }));
    } else {
      applyFilters();
    }
  }, [threadDeleteBulkIDs.length, isMobile]);
  //connection data for filter
  useEffect(() => {
    if (!Array.isArray(connectionData)) {
      setConndata([]);
      return;
    }
    const processed = connectionData
      .filter(item => item.IsCold !== 1 && item.IsCold !== true)
      .map(item => ({
        connID: item.ConnID,
        bizName: item.BizName || "",
        contactName: item.ContactName || ""
      }))
      .sort((a, b) => (a.bizName || "").localeCompare(b.bizName || ""));
    setConndata(processed);
  }, [connectionData]);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("threads-bulk-selection-changed", {
        detail: { selectionCount: threadDeleteBulkIDs.length }
      })
    );
  }, [threadDeleteBulkIDs.length]);

  useEffect(() => {
    const handleReassignClick = () => {
      if (threadDeleteBulkIDs.length > 0) {
        setReassignDialogOpen(true);
      }
    };

    window.addEventListener("open-threads-reassign-dialog", handleReassignClick);
    return () => {
      window.removeEventListener("open-threads-reassign-dialog", handleReassignClick);
    };
  }, [threadDeleteBulkIDs.length]);

  //Threadtype wise counts
  useEffect(() => {
    if (!Array.isArray(sourceThreads)) return;
    const countMap = {};
    for (const item of sourceThreads) {
      const typeID = item.TypeID ?? "Unknown";
      countMap[typeID] = (countMap[typeID] || 0) + 1;
    }
    setThreadTypeCnt(countMap);
  }, [sourceThreads]);

  //routing logic
  useEffect(() => {
    setIsLoading(true);
    if (!threadType) {
      const displayName = isInqOnlyMode ? "Inquiries" : "Threads";
      setThreadTypeInfo({ typeID: 0, typeName: displayName, typeNameSng: "Inquiry", snSng: "Inquiry" });
      if (!embedded) {
        navigate({
          pathname: location.pathname,
        }, { replace: true });
      }
    } else {
      setThreadTypeInfo({ typeID: tID, typeName: threadType.Typ, typeNameSng: threadType.TypSng, snSng: threadType.SnSng });
      // setTimeout(() => {
      //   window.history.replaceState({}, "", `/Web${location.pathname}`);
      // }, 0);
    }

    if (!embedded && (!isMobile || threadModeType)) {
      setThreads([]);
      setFilteredThreads([]);
    }

    if (threadModeType === "P") {
      setModeValue("Processed");
    }

    if (!isMobile && (paramConnID !== '' || paramStage !== '')) {
      setIsFilterSelected(true);
    } else if (!starParam && !embedded) {
      // Only reset filters if there's no star param from URL and not embedded
      setIsFilterSelected(false);
      handleResetFilters();
    }

    setIsLoading(false);
  }, [threadType, location.pathname, isMobile, threadModeType, isInqOnlyMode]);

  useEffect(() => {
    // Always update starOnly based on URL param, whether it's present or not
    const starOnlyValue = effectiveStarParam === "1";
    setSelectedFilters(prev => ({
      ...prev,
      starOnly: starOnlyValue
    }));
    setTempFilters(prev => ({
      ...prev,
      starOnly: starOnlyValue
    }));
  }, [effectiveStarParam, location.search]);

  // Function to fetch data from API
  const fetchProcessedData = async () => {
    try {
      dispatch(setGlobalLoading(true))
      const params = {
        statusID: "2",
        threadTypeID: "0",
        prdType: "ALL",
        prdQty: "0",
        year: "0",
        month: "0",
      };
      const data = await getThreadsAPI(params);
      checkAPIResponse(data);
      const archivedThreads = JSON.parse(data.updatePackage);
      // const dbThreads = archivedThreads.Table1 || [];
      const dbThreads = [];
      const connLookup = Object.fromEntries(
        (Array.isArray(connectionData) ? connectionData : []).map(item => [
          item.ConnID,
          {
            connID: item.ConnID,
            bizName: item.BizName,
            cc: item.CC,
            contactName: item.ContactName,
            email: item.Email,
            mobile: item.Mobile,
            task: item.Tasks,
          }
        ])
      );

      // Merge connection details into each thread
      const merged = dbThreads.map(thread => ({
        ...thread,
        ...connLookup[thread.ConnID]
      }));

      return merged;
    } catch (error) {
      console.error("Error fetching processed data:", error);
      return [];
    } finally {
      dispatch(setGlobalLoading(false))
    }
  };

  useEffect(() => {
    handleClearSelection();
  }, [selectedFilters]);

  useEffect(() => {
    let isAllowed = false;

    try {
      const record = getConfigData();
      isAllowed = !!record?.WDPreferred?.trim();
    } catch (err) {
      console.error("Failed to parse C cookie", err);
    }

    setIsBulkAllowed(isAllowed);
  }, []);

  // Source data logic
  useEffect(() => {
    const loadData = async () => {
      const isProcessedMode =
        threadModeType === "P" || modeValue === "Processed";
      if (isProcessedMode) {
        setSourceThreads([])
        setThreads([]);
        setFilteredThreads([]);
        const processedData = await fetchProcessedData();
        setSourceThreads(processedData);
      } else {
        setSourceThreads(threadData);
      }
    };
    loadData();
  }, [threadModeType, modeValue, threadData]);

  useEffect(() => {
    handleResetFilters()
  }, [modeValue])

  const mapThreadItem = (item) => {
    // If merged data from Redux already has conn fields at root, fallback to item.connectionData
    const currentConn = {
      bizName: item.bizName ?? item.connectionData?.BizName,
      contactName: item.contactName ?? item.connectionData?.ContactName,
      cc: item.cc ?? item.connectionData?.CC,
      mobile: item.mobile ?? item.connectionData?.Mobile,
      email: item.email ?? item.connectionData?.Email,
      tasks: item.connectionData?.Tasks,
      lastRecDT: item.lastRec ?? item.connectionData?.LastRecDT,
      category: item.connectionData?.Segment || ''
    };
    const currentParsedTasks = safeParseArray(currentConn?.tasks);
    const currentThreadID = item.ThreadID;
    const includesThreadID = (tIDs) =>
      tIDs?.split(",").some((t) => +t.trim() === currentThreadID);

    let nextTask = null;
    for (const task of currentParsedTasks) {
      if (!task?.TIDs || !task?.DT || !includesThreadID(task.TIDs)) continue;
      if (Number(task.Sts ?? task.status ?? 0) !== 1) continue;
      if (!nextTask || task.DT < nextTask.DT) nextTask = task;
    }

    let inqTasks = safeParseArray(item?.connectionData?.Tasks)?.filter((task) => Number(task.Sts ?? task.status ?? 0) === 1)
    let sortedTask = inqTasks?.sort((task1, task2) => {
      const date1 = new Date(task1?.DT);
      const date2 = new Date(task2?.DT);

      // Handle invalid dates by pushing them to the end
      if (isNaN(date1.getTime())) return 1;
      if (isNaN(date2.getTime())) return -1;

      // Sort ascending (earliest date first)
      return date1 - date2;
    }) || [];

    let inqOnlyNextTaskDT = null
    if (sortedTask.length != 0) {
      inqOnlyNextTaskDT = sortedTask[0]?.DT
    }

    const effectiveNextTask = !isInqOnlyMode ? nextTask : sortedTask[0];
    const effectiveNextTaskDT = !isInqOnlyMode ? (nextTask?.DT || item.DueDT) : (inqOnlyNextTaskDT || item.DueDT);

    return {
      threadID: item.ThreadID,
      typeID: item.TypeID,
      agencyID: item.AgencyID,
      connID: item.ConnID,
      mainProduct: item.MainProduct,
      mainQty: item.MainQty,
      model: item.Model,
      pocUserID: item.POCUserID,
      pocUserName: getExecutiveName(item.POCUserID),
      statusID: item.StatusID,
      dueDT: item.DueDT,
      dueDTF: getTableDateOrWeekday(item.DueDT),
      dueDTColor: getColorClass(getTaskColor(item.DueDT)),
      sinceDT: item.SinceDT,
      sinceDTF: getTableDateOrWeekday(item.SinceDT),
      reference: item.Reference,
      bizProspect: item.BizProspect,
      currStageID: item.CurrStageID,
      stageInfo: getStageInfo(item.TypeID, item.CurrStageID),
      nextTaskDT: effectiveNextTaskDT,
      nextTaskDTColor: getTaskColor(effectiveNextTaskDT),
      nextTaskDTF: getTableDateOrWeekday(effectiveNextTaskDT),
      nextTaskNote: effectiveNextTask?.Txt,
      nextTaskTyp: effectiveNextTask?.Typ,
      lastRecordDT: currentConn?.lastRecDT,
      lastRecordDTColor: getLastDateColor(currentConn?.lastRecDT),
      lastRecordDTF: getTableDateOrWeekday(currentConn?.lastRecDT),
      lastRecordDTAgo: timeAgo(currentConn?.lastRecDT),
      lastRecord: item.lastRecNotes || item.lastRecTxt || item.lastRecord || item.connectionData?.LastRec || item.LastRec || "-",
      lastStageChgDT: item?.LastStageChgDT || null,
      notes: item.Notes,
      thrFile: item.ThrFile,
      source: item.Source,
      connectionData: {
        bizName: currentConn?.bizName,
        contactName: currentConn?.contactName,
        cc: currentConn?.cc,
        mobile: currentConn?.mobile,
        email: currentConn?.email,
        tasks: currentParsedTasks,
        ConnType: item.connectionData?.ConnType,
        category: item.connectionData?.Segment || ''
      },
      feedbackNotes: item.FdbkNotes,
      feedbackScore: item.FdbkScore,
      failureReason: item.FailureReason,
      isChecked: false,
      isStar: item.IsStar === 1 || item.IsStar === true,
    };
  };

  // Memo only runs when the right data is ready
  const processedThreads = useMemo(() => {
    if (!Array.isArray(sourceThreads) || sourceThreads.length === 0) {
      return [];
    }
    return sourceThreads.map(mapThreadItem);

    const baseList =
      modeValue === "Open"
        ? sourceThreads.filter(item => item.StatusID === 0)
        : sourceThreads;

    return baseList.map(mapThreadItem);
  }, [sourceThreads, modeValue, isMobile]);
  // Only update when data is ready
  useEffect(() => {
    setIsLoading(true);
    setThreads(processedThreads);
    const categories = getUniqueCategoriesFromThreads(processedThreads);
    setAvailableCategories(categories);
    setIsLoading(false);
  }, [processedThreads]);

  // Apply filters synchronously when threads or filters update
  useEffect(() => {
    applyFilters();
  }, [threads, selectedFilters]);

  useEffect(() => {
    if (embedded && onCountChange) {
      const totalAmt = (preSearchThreads || []).reduce((sum, item) => sum + (Number(item.bizProspect || item.BizProspect || item.amount || item.Amt || 0) || 0), 0);
      onCountChange(preSearchThreads.length, totalAmt);
    }
  }, [embedded, preSearchThreads, onCountChange]);

  //managing paramConnID params
  useEffect(() => {
    const conn = searchParams.get("cid");
    const stage = searchParams.get("stg");
    let threadId = searchParams.get("thrid");

    if (threadId) {
      const paramthrIDArray = threadId.split('?');
      threadId = paramthrIDArray.length > 0 ? paramthrIDArray[0]?.trim() : threadId;
    }

    if (conn && conn !== paramConnID) {
      setParamConnID(conn);
    } else if (!conn && paramConnID) {
      setParamConnID('');
    }

    if (stage && stage !== paramStage) {
      setParamStage(Number(stage));
    } else if (!stage && paramStage) {
      setParamStage('');
    }

    if (threadId) {
      setIsThrIdFromParams(true);
      setPendingThreadId(Number(threadId));
    }
  }, [location.search]);

  useEffect(() => {
    if (pendingThreadId && threads.length > 0 && !isLoading) {
      const thread = threads.find(t => t.threadID === pendingThreadId);
      if (thread) {
        setSelectedThread(thread);
        if (isMobile) {
          setSelectedConnID(thread?.connID);
          setIsMobileConnDetailOpen(true);
          // Use the stored state instead of checking URL
          setIsMobileContactActionsOpen(isThrIdFromParams);
        } else {
          if (isInqOnlyMode) {
            setSelectedConnID(thread?.connID);
            setIsConnDetailOpen(true);
          } else {
            setIsThreadDetailsOpen(true);
          }
        }
        setPendingThreadId(null); // Clear pending ID after opening
        setIsThrIdFromParams(false); // Reset the flag

        // Remove threadId from URL after opening
        const params = new URLSearchParams(location.search);
        params.delete('thrid');
        const newSearch = params.toString();
        navigate(
          `${location.pathname}${newSearch ? `?${newSearch}` : ''}`,
          { replace: true }
        );
      }
    }
  }, [pendingThreadId, threads, isLoading, isMobile]);

  useEffect(() => {
    const paramMap = {
      connID: paramConnID,
      stage: paramStage,
    };

    Object.entries(paramMap).forEach(([key, value]) => {
      if (value !== '') {
        setSelectedFilters(prev => ({
          ...prev,
          [key]: value,
        }));
        setTempFilters(prev => ({
          ...prev,
          [key]: value,
        }));
        if (!isMobile) {
          setIsFilterSelected(true);
        }
      }
    });
  }, [paramConnID, paramStage, isMobile]);


  const isThreadsEmpty = () => !threads || threads.length === 0;

  const isRecordInDateRange = (recordDate, dateRange, finYear, otherMonth, otherQuarter, otherYear) => {
    const recordDT = new Date(recordDate);
    const now = new Date();

    // Handle "all" value which represents all time periods
    if (dateRange === "all") return true;

    switch (dateRange) {
      case "This Month":
        return recordDT.getMonth() === now.getMonth() &&
          recordDT.getFullYear() === now.getFullYear();

      case "Last Month":
        const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1);
        return recordDT.getMonth() === lastMonth.getMonth() &&
          recordDT.getFullYear() === lastMonth.getFullYear();

      case "This Quarter":
        const currentQuarter = Math.floor(now.getMonth() / 3);
        const recordQuarter = Math.floor(recordDT.getMonth() / 3);
        return recordQuarter === currentQuarter &&
          recordDT.getFullYear() === now.getFullYear();

      case "Prev Quarter":
        const prevQuarterDate = new Date(now.getFullYear(), now.getMonth() - 3);
        const prevQuarter = Math.floor(prevQuarterDate.getMonth() / 3);
        return Math.floor(recordDT.getMonth() / 3) === prevQuarter &&
          recordDT.getFullYear() === prevQuarterDate.getFullYear();

      case "Fin Year":
        if (finYear === "all") return true;
        const [startYear, endYear] = finYear.split('-').map(Number);
        const recordYear = recordDT.getFullYear();
        const recordMonth = recordDT.getMonth();

        if (recordMonth >= 3) {
          return recordYear === startYear;
        } else {
          return recordYear === endYear;
        }

      case "Other Month":
        if (otherMonth === "all") return true;
        const [monthName, year] = otherMonth.split(' ');
        const monthIndex = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
          .indexOf(monthName);
        return recordDT.getMonth() === monthIndex &&
          recordDT.getFullYear() === parseInt(year);

      case "Other Quarter":
        if (otherQuarter === "all") return true;
        const quarterParts = otherQuarter.split(' ');
        if (quarterParts.length < 2) return true;
        const quarterYear = parseInt(quarterParts[quarterParts.length - 1]);
        const quarterNum = parseInt(quarterParts[0].replace('Q', '')) - 1; // Q1 -> 0, Q2 -> 1, etc.
        const recordRecordQuarter = Math.floor(recordDT.getMonth() / 3);
        return recordRecordQuarter === quarterNum && recordDT.getFullYear() === quarterYear;

      case "Other Year":
        if (otherYear === "all") return true;
        const otherYearNum = parseInt(otherYear);
        return recordDT.getFullYear() === otherYearNum;

      case "Today":
        return recordDT.getDate() === now.getDate() &&
          recordDT.getMonth() === now.getMonth() &&
          recordDT.getFullYear() === now.getFullYear();

      case "Yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);
        return recordDT.getDate() === yesterday.getDate() &&
          recordDT.getMonth() === yesterday.getMonth() &&
          recordDT.getFullYear() === yesterday.getFullYear();

      case "Last 7 days":
        const last7Days = new Date(now);
        last7Days.setDate(now.getDate() - 7);
        return recordDT >= last7Days && recordDT <= now;

      default:
        return true;
    }
  };

  const resetSort = () => {
    setSortConfig({ key: null, direction: null });
  };

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((o, k) => (o ? o[k] : ""), obj);
  };

  const sortData = (key, dir) => {
    if (!key && !dir) return;
    const actualKey = sortKeyMap[key] || key;
    let direction =
      dir ??
      (sortConfig.key === actualKey && sortConfig.direction === "asc" ? "desc" : "asc");
    setSortConfig({ key: actualKey, direction });
    const sorted = [...filteredThreads].sort((a, b) => {
      let lowerVal, upperVal;
      const now = Date.now();

      // InactivePeriod (days since lastRecordDT)
      if (key === "inactive") {
        const getDaysSince = (str) => {
          const dt = new Date(str);
          return isNaN(dt) ? Infinity : Math.floor((now - dt.getTime()) / (1000 * 60 * 60 * 24));
        };
        lowerVal = getDaysSince(a.lastRecordDT);
        upperVal = getDaysSince(b.lastRecordDT);
        return direction === "asc" ? lowerVal - upperVal : upperVal - lowerVal;
      }
      lowerVal = getNestedValue(a, actualKey);
      upperVal = getNestedValue(b, actualKey);

      // Handle numeric fields
      if (["bizProspect"].includes(key)) {
        lowerVal = Number(lowerVal) || 0;
        upperVal = Number(upperVal) || 0;
        return direction === "asc" ? lowerVal - upperVal : upperVal - lowerVal;
      }

      // Handle date fields
      if (["sinceDT", "dueDT", "lastRecordDT", "nextTaskDT"].includes(key)) {
        lowerVal = lowerVal ? new Date(lowerVal).getTime() : 0;
        upperVal = upperVal ? new Date(upperVal).getTime() : 0;
        return direction === "asc" ? lowerVal - upperVal : upperVal - lowerVal;
      }

      // Handle string fields
      lowerVal = lowerVal?.toString().toLowerCase() || "";
      upperVal = upperVal?.toString().toLowerCase() || "";

      return direction === "asc"
        ? lowerVal.localeCompare(upperVal)
        : upperVal.localeCompare(lowerVal);
    });
    setFilteredThreads(sorted);
    setPreSearchThreads(sorted);
  };

  const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const getDateRangeFilter = (value, passedDt) => {
    if (!passedDt) return false;
    const todayDT = new Date();
    const currDT = new Date(passedDt);

    switch (value) {
      case "Overdue":
        return currDT < todayDT;
      case "Yesterday":
        const yest = new Date(todayDT);
        yest.setDate(todayDT.getDate() - 1);
        return isSameDay(currDT, yest);
      case "Today":
        return isSameDay(currDT, todayDT);
      case "Tomorrow":
        const tmr = new Date(todayDT);
        tmr.setDate(todayDT.getDate() + 1);
        return isSameDay(currDT, tmr);
      case "This week":
        const endOfWeek = new Date(todayDT);
        endOfWeek.setDate(todayDT.getDate() + (6 - todayDT.getDay()));
        return currDT >= todayDT && currDT <= endOfWeek;
      case "Next 7 days":
        const next7 = new Date(todayDT);
        next7.setDate(todayDT.getDate() + 7);
        return currDT >= todayDT && currDT <= next7;
      case "Next 30 days":
        const next30 = new Date(todayDT);
        next30.setDate(todayDT.getDate() + 30);
        return currDT >= todayDT && currDT <= next30;
      case "Last 7 days":
        const last7 = new Date(todayDT);
        last7.setDate(todayDT.getDate() - 7);
        return currDT >= last7 && currDT <= todayDT;
      case "Last month":
        const lastMonth = new Date(todayDT);
        lastMonth.setMonth(todayDT.getMonth() - 1);
        return currDT >= lastMonth && currDT <= todayDT;
      default:
        return true;
    }
  };

  useEffect(() => {
    const term = searchTerm.trim().toLowerCase();

    if (!term) {
      setFilteredThreads(preSearchThreads);
      return;
    }

    const filtered = preSearchThreads.filter((thread) => {
      const data = thread.connectionData || {};
      const fieldsToSearch = [
        data.contactName,
        data.bizName,
        data.email,
        data.mobile,
        thread.mainProduct,
        thread.product,
        thread.bizProspect?.toString(),
        thread.source,
        thread.Source,
        thread.src,
        thread.Src,
      ];

      return fieldsToSearch
        .filter(Boolean)
        .some((field) =>
          field.toString().toLowerCase().includes(term)
        );
    });

    setFilteredThreads(filtered);
    setCurrentPage(1);
  }, [searchTerm, preSearchThreads]);

  const applyFilters = () => {
    setIsLoading(true);
    const {
      stage,
      assignedTo,
      receivedOn,
      dueOn,
      lastRecordOn,
      nextTaskOn,
      types,
      connID,
      dateRange,
      finYear,
      otherMonth,
      otherQuarter,
      otherYear,
      fromDate,
      toDate,
      connType,
      category,
      stageExpiry, // NEW - destructure the new filter
      starOnly, // Add starOnly to destructuring
      selectDate,
      selectedDate,
    } = selectedFilters;

    // Store current sort before filtering
    const currentSort = { ...sortConfig };

    // Header configuration logic
    let selectedHeader = {};
    if (types && types.length === 1) {
      const threadType = threadTypes.find((t) => t.TID === Number(types));
      if (threadType) {
        setThreadTypeInfo({
          typeID: threadType.TID,
          typeName: threadType.Typ,
          typeNameSng: threadType.TypSng,
          snSng: threadType.SnSng
        });
        selectedHeader = {
          title: (isInqOnlyMode && threadType.TID === 2) ? "Sales" : threadType.Typ,
          iconLeft: {
            icon: ArrowLeft,
            onClick: () => navigate(-1),
          },
          actionsRight: (userRights?.addThr && canShowImportInquiries()) ? [{
            icon: FaDownload,
            onClick: () => setIntegrationsOpen(true),
          }] : [],
        };
      } else {
        const displayName = isInqOnlyMode ? "Inquiries" : "Threads";
        setThreadTypeInfo({
          typeID: 0,
          typeName: displayName,
          typeNameSng: "Inquiry",
          snSng: "Inquiry"
        });
        selectedHeader = {
          title: displayName,
          iconLeft: {
            icon: ArrowLeft,
            onClick: () => navigate(-1),
          },
          actionRights: (userRights?.addThr && canShowImportInquiries()) ? [
            {
              icon: FaDownload,
              onClick: () => setIntegrationsOpen(true),
            },
          ] : [],
        };
      }
      if (!embedded) {
        dispatch(updateHeaderConfig(selectedHeader));
      }
    } else {
      const displayName = isInqOnlyMode ? "Inquiries" : "Threads";
      selectedHeader = {
        title: displayName,
        iconLeft: {
          icon: ArrowLeft,
          onClick: () => navigate(-1),
        },
        actionRights: (userRights?.addThr && canShowImportInquiries()) ? [
          {
            icon: FaDownload,
            onClick: () => setIntegrationsOpen(true),
          },
        ] : [],
      };
      if (!embedded) {
        dispatch(updateHeaderConfig(selectedHeader));
      }
      setThreadTypeInfo({ typeID: 0, typeName: displayName, typeNameSng: "Inquiry", snSng: "Inquiry" });
    }

    const isFilterAdded = (curr, prev) => {
      return (
        (prev === "all" && curr !== "all") || (prev === undefined && curr !== "all")
      );
    };

    const prev = prevFiltersRef.current;
    const isEmptyPrev = !prev || Object.keys(prev).length === 0;

    const isRefined =
      isFilterAdded(stage, prev.stage) ||
      isFilterAdded(assignedTo, prev.assignedTo) ||
      isFilterAdded(receivedOn, prev.receivedOn) ||
      isFilterAdded(dueOn, prev.dueOn) ||
      isFilterAdded(connID, prev.connID) ||
      isFilterAdded(nextTaskOn, prev.nextTaskOn) ||
      isFilterAdded(lastRecordOn, prev.lastRecordOn) ||
      isFilterAdded(dateRange, prev.dateRange) ||
      isFilterAdded(finYear, prev.finYear) ||
      isFilterAdded(otherMonth, prev.otherMonth) ||
      isFilterAdded(connType, prev.connType) ||
      isFilterAdded(category, prev.category) ||
      isFilterAdded(stageExpiry, prev.stageExpiry) ||
      (starOnly !== false && starOnly !== prev.starOnly);

    const baseList = threads;
    const filtered = [];

    for (const thread of baseList) {
      if (thread.statusID !== 0) {
        continue;
      }

      // Exclude threads from cold contacts
      const threadConnection = connectionData?.find(conn => conn.ConnID === thread.connID);
      if (threadConnection && (threadConnection.IsCold === 1 || threadConnection.IsCold === true)) {
        continue;
      }

      // Stage filter
      if (stage !== "all" && Number(thread.stageInfo?.SID) !== Number(stage)) continue;

      // Types filter
      if (types && types !== "" && types !== getAllThreadTypesString()) {
        if (types.length === 1) {
          setHideTypeColumn(true);
        } else {
          setHideTypeColumn(false)
        }
        if (!types.toString().includes(thread.typeID.toString())) {
          continue;
        }
      } else {
        setHideTypeColumn(false);
      }

      // Connection Type filter (only apply if Sales Inquiries is selected)
      if (types === "1") {
        setHideTypeColumn(true);
        const connTypeFilter = connType;
        if (connTypeFilter !== "all" && connTypeFilter !== "") {
          if (!connTypeFilter.includes(thread.connectionData?.ConnType)) {
            continue;
          }
        }
      }

      // Category filter
      if (category && category !== "all") {
        const threadCategory = thread.connectionData?.category || "";
        if (threadCategory !== category) {
          continue;
        }
      }

      if (connID && connID !== "all") {
        if (thread.connID.toString() !== connID.toString()) continue;
      }

      // Assigned To filter
      if (assignedTo !== "all") {
        if (assignedTo === "unassigned") {
          if (thread.pocUserID) continue;
        } else {
          const threadUserID = +thread.pocUserID;
          const selectedUserID = +assignedTo;
          if (threadUserID !== selectedUserID) continue;
        }
      }

      // Received On filter
      if (receivedOn !== "all" && !getDateRangeFilter(receivedOn, thread.sinceDT)) continue;

      // Due On filter
      if (dueOn !== "all" && !getDateRangeFilter(dueOn, thread.dueDT)) continue;

      // Next Task On filter
      if (nextTaskOn !== "all") {
        if (nextTaskOn === "Not set" && thread.nextTaskDT) continue;
        if (nextTaskOn !== "Not set" && !getDateRangeFilter(nextTaskOn, thread.nextTaskDT)) continue;
      }

      // Date range filter for processed data
      if (!isRecordInDateRange(thread.sinceDT, dateRange, finYear, otherMonth, otherQuarter, otherYear)) {
        continue;
      }

      // Custom date range filter (from/to dates when a month is selected)
      if (dateRange === "Other Month" && otherMonth !== "all") {
        if (fromDate || toDate) {
          const threadDate = new Date(thread.sinceDT);
          threadDate.setHours(0, 0, 0, 0);

          if (fromDate) {
            const from = new Date(fromDate);
            from.setHours(0, 0, 0, 0);
            if (threadDate < from) continue;
          }

          if (toDate) {
            const to = new Date(toDate);
            to.setHours(0, 0, 0, 0);
            if (threadDate > to) continue;
          }
        }
      }

      // Custom date range filter (from/to dates when This Month is selected)
      if (dateRange === "This Month") {
        if (fromDate || toDate) {
          const threadDate = new Date(thread.sinceDT);
          threadDate.setHours(0, 0, 0, 0);

          if (fromDate) {
            const from = new Date(fromDate);
            from.setHours(0, 0, 0, 0);
            if (threadDate < from) continue;
          }

          if (toDate) {
            const to = new Date(toDate);
            to.setHours(0, 0, 0, 0);
            if (threadDate > to) continue;
          }
        }
      }

      // NEW: Stage Expiry filter
      if (stageExpiry === true) { // Changed: only filter when true
        const isExpired = isThrStgExpird(
          thread.lastStageChgDT,
          thread.typeID,
          thread.currStageID,
          threadStages
        );

        // Only show expired threads when checkbox is checked
        if (!isExpired) continue;
      }

      // Star filter
      if (starOnly) {
        if (!thread.isStar) {
          continue;
        }
      }

      if (selectDate && selectedDate) {
        const threadDateStr = thread.sinceDT ? thread.sinceDT.split('T')[0] : "";
        const selectedDateStr = selectedDate;

        if (threadDateStr !== selectedDateStr) {
          continue;
        }
      }

      // Passed all filters
      filtered.push(thread);
    }

    setFilteredThreads(filtered);
    setPreSearchThreads(filtered);
    if (embedded && onCountChange) {
      const totalAmt = (filtered || []).reduce((sum, item) => sum + (Number(item.bizProspect || item.BizProspect || item.amount || item.Amt || 0) || 0), 0);
      onCountChange(filtered.length, totalAmt);
    }

    // Save current filters for next comparison
    prevFiltersRef.current = {
      stage, assignedTo, receivedOn, dueOn, lastRecordOn,
      nextTaskOn, types, connID, dateRange, finYear, otherMonth,
      otherQuarter, otherYear, fromDate, toDate,
      connType, category, stageExpiry, starOnly, selectDate, selectedDate // NEW - include in prevFiltersRef and starOnly
    };

    // Reapply sorting if it was active
    if (currentSort.key && currentSort.direction) {
      setSortConfig(currentSort);
      // Trigger sort after state update
      setTimeout(() => {
        sortData(currentSort.key, currentSort.direction);
      }, 0);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedFilters, threadTypeInfo.typeID]);

  // Pagination - Calculate based on filtered data by type
  const getTypeFilteredCount = () => {
    const currentTypeID = Number(threadTypeInfo.typeID);
    if (currentTypeID === 0) {
      return filteredThreads.length;
    }
    return filteredThreads.filter((t) => Number(t.typeID) === currentTypeID).length;
  };

  const typeFilteredCount = getTypeFilteredCount();
  const totalPages = Math.max(1, Math.ceil(typeFilteredCount / rowsPerPage));
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  // Always sort before slicing for pagination
  // First filter by typeID regardless of device
  // shows the current data via currentThreads
  const currentThreads = useMemo(() => {
    const currentTypeID = Number(threadTypeInfo.typeID);

    const typeFiltered = currentTypeID === 0
      ? filteredThreads
      : filteredThreads.filter((t) => Number(t.typeID) === currentTypeID);

    // Only apply default sort if sortConfig.key is null AND it hasn't been set before
    const sorted = !sortConfig.key && !sortConfig.direction
      ? [...typeFiltered].sort((a, b) => {
        const lowerDate = a.sinceDT ? new Date(a.sinceDT).getTime() : 0;
        const upperDate = b.sinceDT ? new Date(b.sinceDT).getTime() : 0;
        return upperDate - lowerDate;
      })
      : typeFiltered;

    // Mobile uses virtualizer for all data
    if (isMobile) return sorted;

    // Desktop: Apply pagination slicing
    const sliced = sorted.slice(startIndex, endIndex);
    return sliced;
  }, [filteredThreads, sortConfig, currentPage, rowsPerPage, isMobile, threadTypeInfo.typeID, startIndex, endIndex]);

  const rowVirtualizer = useVirtualizer({
    count: currentThreads.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 140, // Estimated row/card height in px
    overscan: 5,
  });

  // Re-measure virtualizer when tab becomes active/visible again
  useEffect(() => {
    if (!embedded || parentActiveTab === 'inquiries' || parentActiveTab === '') {
      const timer = setTimeout(() => {
        if (rowVirtualizer && typeof rowVirtualizer.measure === 'function') {
          rowVirtualizer.measure();
        }
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [parentActiveTab, embedded, currentThreads.length]);

  // Validate currentPage doesn't exceed totalPages
  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  // Cancel/Close Drawer of filters so data wont be affected
  const handleCancel = () => {
    setTempFilters(selectedFilters); // Revert changes
    setIsFilterSelected(false);
    setIsDrawerOpen(false); // Close the drawer
    setTempsortConfig(sortConfig);
  };

  const handleResetFilters = () => {
    const starOnlyPreserved = effectiveStarParam === "1";
    const cleared = {
      stage: "all",
      assignedTo: "all",
      receivedOn: "all",
      dueOn: "all",
      lastRecordOn: "all",
      nextTaskOn: "all",
      types: tID && Number(tID) !== 0 ? String(tID) : getAllThreadTypesString(),
      connID: "all",
      dateRange: "all",
      finYear: "all",
      otherMonth: "all",
      category: "all",
      connType: "all",
      stageExpiry: false,
      starOnly: starOnlyPreserved // Preserve star filter from URL param
    };
    resetSort();
    setSelectedFilters(cleared);
    setSearchTerm("");
    setIsDrawerOpen(false);
    setTempFilters(cleared);
    setTempsortConfig({ key: null, direction: null });
    setSearchTerm("");
    setSortConfig({ key: null, direction: null });
    const selectedHeader = {
      title: "Threads",
      iconLeft: {
        icon: ArrowLeft,
        onClick: () => navigate(-1),
      },
      actionRights: (userRights?.addThr && canShowImportInquiries()) ? [
        {
          icon: FaDownload,
          onClick: () => setIntegrationsOpen(true),
        },
      ] : [],
    };
    if (!embedded) {
      dispatch(updateHeaderConfig(selectedHeader));
    }
  };

  const MobileCard = ({ thread, threadTypeInfo, threadTypes, checked, onCheckedChange }) => {
    const isTIDZero = threadTypeInfo.typeID === 0;
    const agencyData = getAgencyData();
    const countryID = agencyData?.CountryID || "";

    // Memoize thread type meta calculation
    const threadTypeMeta = useMemo(() => {
      if (!isTIDZero) return null;
      return getThreadTypeMeta(thread.typeID, threadTypes);
    }, [isTIDZero, thread.typeID, threadTypes]);

    return (
      <div
        className="bg-sahi-white sahi-radius shadow-sm border border-gray-200 w-full max-w-[94vw] sm:max-w-[] f-col justify-between"
      >
        {/* === Header Section === */}
        <div className="f-col gap-1 mobile-tile-header-layout-v3">
          <div className="f-row justify-between gap-2">
            <div className="f-col items-start justify-between flex-1 min-w-0">
              <div className="f-col min-w-0 gap-1 w-full">
                <p
                  className="font-semibold text-text-color text-sm flex items-center gap-1.5 w-full min-w-0"
                  data-tooltip-id={`bizName-${thread.threadID}`}
                  data-tooltip-content={thread.connectionData?.bizName || thread.connectionData?.contactName || "-"}
                >
                  <span className="truncate">
                    {thread.connectionData?.bizName || thread.connectionData?.contactName || "-"}
                  </span>
                  <Star
                    className={`w-4 h-4 shrink-0 transition-colors cursor-pointer ${thread.isStar ? 'fill-yellow-400 text-yellow-400' : 'text-gray-400'}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleToggleStar(thread, e);
                    }}
                  />
                  {thread.lastStageChgDT && isTIDZero && isThrStgExpird(thread.lastStageChgDT, thread.typeID, thread.currStageID, threadStages) && <FaCircle className={`text-sahi-red text-[10px] inline shrink-0`} />}
                </p>
                <Tooltip id={`bizName-${thread.threadID}`} place="top" />
                <p className="text-xs text-sub-text-color mt-1 truncate">
                  {thread.connectionData?.bizName ? (thread.connectionData?.contactName || "--") : "--"}
                </p>
              </div>
            </div>

            <div className="f-col items-end space-y-1 text-right">
              {/* Status Badge */}
              {isTIDZero ? (
                threadTypeMeta && (
                  <span
                    className={`${threadTypeMeta.colorClass} f-row justify-between gap-1 items-center text-xs font-semibold`}
                  >
                    <ThreadSahiIcon tID={thread.typeID} className="h-3 w-3 xs:h-4 xs:w-4 shrink-0" />
                  </span>
                )
              ) : (
                <Badge
                  className="!bg-[#F3F4F6] !text-sahi-teal !font-semibold !text-xs !px-2 !py-1 !sahi-radius !break-all !whitespace-normal !leading-snug !max-w-[140px] sm:!max-w-[200px]"
                >
                  {thread.lastStageChgDT && isThrStgExpird(thread.lastStageChgDT, thread.typeID, thread.currStageID, threadStages) && <FaCircle className={`text-sahi-red text-[8px] rounded-full inline mr-1`} />}
                  {thread.stageInfo?.name}
                </Badge>
              )}

              {/* Amount */}
              <span className="text-xs text-sub-text-color align-bottom shrink-0 whitespace-nowrap">
                {thread.bizProspect > 0
                  ? `${currencySymbol} ${formatAmount(thread.bizProspect, countryID)}`
                  : "--"}
              </span>
            </div>
          </div>

          <div className="f-row justify-between">
            {/* Product */}
            {thread.mainProduct && (Number(thread.mainQty) > 0 || thread.mainProduct) && (
              <p className="text-xs text-sub-text-color truncate">
                <strong>
                  {`${thread.mainProduct}${Number(thread.mainQty) > 1 ? ` # ${thread.mainQty}` : ""}`}
                </strong>
              </p>
            )}

            {/* Last Contact */}
            {thread.sinceDT ? (
              <span className="text-xs text-sub-text-color truncate">
                Recd:{" "}
                <strong>
                  {thread.sinceDTF || "-"}
                </strong>
              </span>
            ) : (
              <span className="text-xs text-sub-text-color truncate">
                Recd:{" "}
                <strong>
                  {thread.lastRecordDTF || "-"}
                </strong>
              </span>
            )}
          </div>
        </div>

        {/* === Footer Section === */}
        <div className="flex justify-between items-center text-xs border-t border-[#f1f1f1] w-full mobile-tile-footer-layout px-2">

          <div className="flex flex-wrap gap-3 items-center">

            {threadDeleteBulkIDs.length > 0 && (
              <div
                className=""
                onClick={(e) => e.stopPropagation()}
                onTouchStart={(e) => e.stopPropagation()}
                onTouchEnd={(e) => e.stopPropagation()}
              >
                <Checkbox
                  checked={checked}
                  onCheckedChange={onCheckedChange}
                  className={checkBoxCss}
                />
              </div>
            )}

            {/* Next Task */}
            <span className="text-xs whitespace-nowrap text-sub-text-color">

              Next:{" "}
              {thread.nextTaskDT ? (
                <>
                  <strong className="text-xs" style={{ color: thread.nextTaskDTColor }}>
                    {thread.nextTaskDTF}
                  </strong>
                  {thread.nextTaskTyp && ` (${thread.nextTaskTyp})`}
                </>
              ) : (
                <>
                  Not Set
                </>
              )}
            </span>
          </div>

          {/* Contact Actions */}
          <div className="flex gap-5 text-lg justify-end">
            {thread.thrFile && (
              <Tooltip>
                <TooltipTrigger asChild>
                  <a
                    onClick={(e) => handleThreadAction("DOWNLOAD", thread, e)}
                  >
                    <Paperclip className="h-4 w-4 text-sahi-blue" />
                  </a>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Attachment</p>
                </TooltipContent>
              </Tooltip>
            )}
            {thread.connectionData?.mobile && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handlePhoneClickAction(thread.connectionData, isDesktop, null, thread.connID);
                }}
                className="hover:opacity-80 transition-opacity"
              >
                <MdPhone className="w-4.5 h-4.5 text-black" />
              </button>
            )}
            {thread.connectionData?.mobile && (
              <><button
                onClick={async (e) => {
                  e.stopPropagation();
                  setTemplateDialogOpen(true);
                  setActiveConnection({
                    connectionData: thread.connectionData,
                    connID: thread.connID,
                    currStageID: thread.currStageID
                  });
                }}
                className="text-sahi-green hover:opacity-80 transition-opacity"
              >
                <BsWhatsapp className="w-4.5 h-4.5" />
              </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  const handleSelectAllCurrentPage = (checked) => {
    setSelectAllCurrentPage(checked);

    const currentPageThreadIDs = new Set(currentThreads.map(t => t.threadID));

    setThreads(prevThreads =>
      prevThreads.map(thread =>
        currentPageThreadIDs.has(thread.threadID)
          ? { ...thread, isChecked: checked }
          : thread
      )
    );

    setFilteredThreads(prevFilteredThreads =>
      prevFilteredThreads.map(thread =>
        currentPageThreadIDs.has(thread.threadID)
          ? { ...thread, isChecked: checked }
          : thread
      )
    );
  };

  const handleSelectAllFiltered = (checked) => {
    setThreads(prevThreads =>
      prevThreads.map(thread =>
        filteredThreads.find(ft => ft.threadID === thread.threadID)
          ? { ...thread, isChecked: checked }
          : thread
      )
    );

    setFilteredThreads(prevFilteredThreads =>
      prevFilteredThreads.map(thread => ({ ...thread, isChecked: checked }))
    );
  };

  const handleClearSelection = () => {
    setSelectAllCurrentPage(false);
    setThreadDeleteBulkIDs([]);
    setThreads(prevThreads => prevThreads.map(thread => ({ ...thread, isChecked: false })));
    setFilteredThreads(prevFilteredThreads => prevFilteredThreads.map(thread => ({ ...thread, isChecked: false })));
  };

  const getSelectedCountOnCurrentPage = () => {
    return currentThreads.filter(thread => thread.isChecked).length;
  };

  const getSelectedCountAll = () => {
    return filteredThreads.filter(thread => thread.isChecked).length;
  };

  const areAllCurrentPageItemsSelected = () => {
    if (currentThreads.length === 0) return false;
    return currentThreads.every(thread => thread.isChecked);
  };

  const areAllFilteredItemsSelected = () => {
    if (filteredThreads.length === 0) return false;
    return filteredThreads.every(thread => thread.isChecked);
  };

  const handleCheckboxChange = (threadID, checked) => {
    // Use React.startTransition to deprioritize these updates
    // This prevents the re-render from interrupting the sort
    React.startTransition(() => {
      // Update both threads and filteredThreads in a single batch
      setThreads(prevThreads =>
        prevThreads.map(thread =>
          thread.threadID === threadID
            ? { ...thread, isChecked: checked }
            : thread
        )
      );

      setFilteredThreads(prevFilteredThreads =>
        prevFilteredThreads.map(thread =>
          thread.threadID === threadID
            ? { ...thread, isChecked: checked }
            : thread
        )
      );

      // Update bulk IDs
      setThreadDeleteBulkIDs(prev => {
        if (checked) {
          return [...prev, threadID];
        } else {
          return prev.filter(id => id !== threadID);
        }
      });
    });
  };

  useEffect(() => {
    const checkedThreadIds = filteredThreads
      .filter(thread => thread.isChecked)
      .map(thread => thread.threadID);

    setThreadDeleteBulkIDs(checkedThreadIds);
  }, [filteredThreads]);

  const WebDataTable = () => {
    return (
      <>
        {loading ? (
          <div className="flex justify-center items-center w-full h-full">
            <Loader2 className="h-8 w-8 animate-spin text-sahi-primary-color mr-3" />
            <span className="text-text-color">
              {`Loading`}
            </span>
          </div>) : (
          currentThreads.length === 0 ? (
            <>
              <div className="f-col items-start gap-5 !mt-0">
                <div className="no-records border border-gray-200 shadow-sm sahi-radius">
                  No {toAllWordsLowerCase(threadTypes[threadTypeInfo.typeID - 1]?.Typ ?? "threads")} {hasActiveFilters ? 'found for selected filters.' : 'found.'}
                  {hasActiveFilters && (
                    <span
                      onClick={handleResetFilters}
                      className="ml-2 text-sahi-primary-color underline hover:text-sahi-primary-color/80 cursor-pointer inline-block"
                    > Clear filter.</span>
                  )}
                </div>

                {userRights?.addThr && (
                  <div className="flex items-center gap-3">
                    <ThreadDropdown
                      onThreadTypeSelect={handleThreadTypeSelect}
                      iconButton={false}
                      activeFilteredTypes={selectedFilters.types}
                    />
                  </div>
                )}

                {/* {(() => {
                  const selectedTypes = selectedFilters.types;
                  if (!selectedTypes || selectedTypes.length !== 1) return null;

                  const selectedTypeID = parseInt(selectedTypes);
                  if (selectedTypeID === 1) {
                    return <Integrations buttonText="Inquiries" threadInfo={{ ...threadTypeInfo, importType: "inquiry" }} />;
                  } else if (selectedTypeID === 2) {
                    return <ImportThreadsExcel
                      open={true}
                      threadInfo={{ ...threadTypeInfo, importType: "order" }}
                      triggerButton={false}
                    />;
                  }
                  return null;
                })()} */}
              </div>
            </>
          ) : (
            <>
              <Card className={`bg-sahi-white hidden lg:block !pt-0 overflow-hidden ${!isFilterSelected && isInqOnlyMode && '!mt-0'}`}>
                <CardContent className="px--5 !sahi-radius">
                  <Table className="min-w-full table-auto">
                    <TableHeader>
                      <TableRow className="bg-sahi-white py-1.5 h-11" >
                        {(thrActions != 0 && hideTypeColumn) && (
                          <TableHead className="table-header-text whitespace-nowrap text-left pr-2 align-top w-fit py-2 px-4">
                            <div
                              className="flex items-center justify-center py-1 user-select-none cursor-pointer"
                              style={{ userSelect: 'none' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSelectAllCurrentPage(!areAllCurrentPageItemsSelected());
                              }}
                            >
                              <Checkbox
                                checked={areAllCurrentPageItemsSelected()}
                                onCheckedChange={(checked) => handleSelectAllCurrentPage(checked)}
                                onClick={(e) => e.stopPropagation()}
                                className={`${checkBoxCss} user-select-none`}
                                style={{ userSelect: 'none' }}
                              />
                            </div>
                          </TableHead>
                        )}
                        {getFilteredHeaders().map(
                          ({ key, label, className = "", style = {} }) => (
                            <TableHead
                              key={key}
                              className={`table-header-text word-break-px `}
                              style={style}
                              onClick={() => sortData(key)}
                            >
                              <div className={`flex items-center cursor-pointer break-words ${className}`}>
                                {label}
                                {sortConfig.key === (sortKeyMap[key] || key) &&
                                  sortConfig.direction &&
                                  (sortConfig.direction === "asc" ? (
                                    <ArrowUp className="ml-1 h-4 w-4 text-black" />
                                  ) : (
                                    <ArrowDown className="ml-1 h-4 w-4 text-black" />
                                  ))}
                              </div>
                            </TableHead>
                          )
                        )}
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {currentThreads.map((thread) => (
                        <TableRow
                          key={thread.threadID}
                          className="hover:bg-gray-50 cursor-pointer"
                          onClick={() => handleRowClick(thread)}
                        >
                          {!hideTypeColumn && columnVisibility.type ? (
                            <TableCell className="w-[1vw] px-4 text-center">
                              <div className="flex items-center justify-center gap-4">
                                <Tooltip>
                                  <TooltipTrigger asChild>
                                    <div className="flex ">
                                      <ThreadSahiIcon tID={thread.typeID} hoverName />
                                    </div>
                                  </TooltipTrigger>
                                  {thread.typeID && (
                                    <TooltipContent side="top" align="start" className="time-tooltip">
                                      <p>{threadTypes.find(tt => tt.TID === thread.typeID)?.TypSng}</p>
                                    </TooltipContent>
                                  )}
                                </Tooltip>
                              </div>
                            </TableCell>
                          ) : (
                            thrActions != 0 && (
                              <TableCell
                                className="w-[1vw] py-2 px-4 text-center user-select-none cursor-pointer"
                                style={{ userSelect: 'none' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCheckboxChange(thread.threadID, !thread.isChecked);
                                }}
                                onDoubleClick={(e) => e.stopPropagation()}
                              >
                                <div className="flex items-center justify-center py-1 -translate-y-0.5" style={{ userSelect: 'none' }}>
                                  <Checkbox
                                    checked={thread.isChecked}
                                    onCheckedChange={(checked) => handleCheckboxChange(thread.threadID, checked)}
                                    onClick={(e) => e.stopPropagation()} // Prevent row click
                                    onDoubleClick={(e) => e.stopPropagation()}
                                    className={`${checkBoxCss} user-select-none`}
                                    style={{ userSelect: 'none' }}
                                  />
                                </div>
                              </TableCell>
                            )
                          )}

                          {thrActions != 0 && hideTypeColumn && (
                            <TableCell className="w-[10px] py-2 px-4 pr-0 text-right user-select-none cursor-pointer" style={{ userSelect: 'none' }} onClick={(e) => {
                              e.stopPropagation();
                              handleToggleStar(thread, e);
                            }}>
                              <div className="flex items-center justify-center py-1 -translate-y-0.5" style={{ userSelect: 'none' }}>
                                <Star className={`w-4 h-4 transition-colors ${thread.isStar ? 'fill-yellow-400 text-yellow-400' : 'text-gray-400'}`} />
                              </div>
                            </TableCell>
                          )}

                          {columnVisibility.bizName && <TableCell
                            key={thread.threadID}
                            className="lg:w-[160px] xl:w-[180px] 2xl:w-[250px] h-full word-break-px text-left pl-0"
                          >
                            <span className={`font-medium text-text-color text-left pl-0 truncate`}>
                              {thread.connectionData?.bizName || thread.connectionData?.contactName || "-"}
                            </span>
                          </TableCell>}

                          {columnVisibility.mobile && <TableCell className="word-non-break-px">
                            {thread?.connectionData?.mobile || "-"}
                          </TableCell>}

                          {columnVisibility.contactName && <TableCell className="word-break-px">
                            <span className="text-text-color">
                              {thread.connectionData?.bizName ? (thread.connectionData?.contactName || "-") : "-"}
                            </span>
                          </TableCell>}

                          {columnVisibility.mainProduct && <TableCell className="word-non-break-px pl-2">
                            {thread.mainProduct || "-"}
                          </TableCell>}

                          {columnVisibility.bizProspect && <TableCell className="word-non-break-px text-right text-nowrap pr-2">
                            <FormatAmount
                              amount={thread.bizProspect}
                              currency={currencySymbol}
                              showCurr={false}
                            />
                          </TableCell>}

                          {columnVisibility.sinceDT && <TableCell className="word-non-break-px">
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <span className="whitespace-nowrap">
                                  {thread.sinceDTF || "-"}
                                </span>
                              </TooltipTrigger>
                              {thread.sinceDT && (
                                <TooltipContent className="time-tooltip">
                                  <p>
                                    {format(thread.sinceDT, "hh:mm a").toUpperCase()}
                                  </p>
                                </TooltipContent>
                              )}
                            </Tooltip>
                          </TableCell>}

                          {columnVisibility.dueDT && (thread.dueDT ? (
                            <TableCell className="word-non-break-px">
                              <span className={`whitespace-nowrap ${thread.dueDTColor}`}>
                                {thread.dueDTF}
                              </span>
                            </TableCell>
                          ) : (
                            <TableCell className="word-non-break-px">-</TableCell>
                          )
                          )}

                          {columnVisibility.reference && threadTypeInfo.typeID != 1 && (
                            <TableCell className="word-non-break-px">
                              {thread?.reference || "-"}
                            </TableCell>
                          )}

                          {columnVisibility.status && <TableCell className="word-break-px pl-2">
                            {thread.currStageID ? (
                              (() => {
                                return (
                                  <p className={`break-words`}>
                                    {thread.stageInfo?.name}
                                    {thread.lastStageChgDT && isThrStgExpird(thread.lastStageChgDT, thread.typeID, thread.currStageID, threadStages) && <FaCircle className={`text-sahi-red text-[10px] inline ml-2`} />}
                                  </p>
                                );
                              })()
                            ) : (
                              <>
                                <p className="text-text-color text-xs">-</p>

                              </>
                            )}
                          </TableCell>}

                          {columnVisibility.nextTaskDT && modeValue !== "Processed" && (thread?.nextTaskDT ? (
                            <TableCell className="word-non-break-px">
                              <Tooltip>
                                <TooltipTrigger asChild>
                                  <span className="block break-words">
                                    <span className={`break-words`} style={{ color: thread?.nextTaskDTColor }}>
                                      {thread?.nextTaskDTF}
                                    </span>
                                    {thread?.nextTaskTyp && (
                                      <>
                                        {" - "}<span className="text-text-color break-words text-xs">{thread?.nextTaskTyp}</span>
                                      </>
                                    )}
                                  </span>
                                </TooltipTrigger>
                                <TooltipContent side="top" align="start" className="time-tooltip">
                                  <p>{format(thread?.nextTaskDT, "hh:mm a").toUpperCase()}</p>
                                </TooltipContent>
                              </Tooltip>
                            </TableCell>
                          ) : (
                            <TableCell className="word-break-px">-</TableCell>
                          )
                          )}

                          {columnVisibility.pocUserName && <TableCell className="word-non-break-px">
                            {thread?.pocUserName || "-"}
                          </TableCell>}

                          {columnVisibility.source && <TableCell className="word-non-break-px">
                            {thread?.source || "-"}
                          </TableCell>}

                          {columnVisibility.email && <TableCell className="word-non-break-px">
                            {thread?.connectionData?.email || "-"}
                          </TableCell>}

                          {columnVisibility.city && <TableCell className="word-non-break-px">
                            {thread?.connectionData?.city || "-"}
                          </TableCell>}

                          {isAgencyAuthorized && columnVisibility.lastInteraction && (
                            thread?.lastRecordDT ? (
                              <TableCell className="word-non-break-px">
                                <Tooltip>
                                  <TooltipTrigger asChild>
                                    <span className={`whitespace-nowrap text-sm font-medium ${thread.lastRecordDTColor || ''}`}>
                                      {thread.lastRecordDTF}
                                    </span>
                                  </TooltipTrigger>
                                  <TooltipContent className="time-tooltip">
                                    <p>{thread.lastRecord}</p>
                                  </TooltipContent>
                                </Tooltip>
                              </TableCell>
                            ) : (
                              <TableCell className="word-non-break-px text-sub-text-color">-</TableCell>
                            )
                          )}
                          <TableCell className="text-right flex justify-end items-center px-2 xl:px-4 w-32">
                            <div className="flex items-center justify-end gap-2 xl:gap-2.5">
                              {thread.thrFile && (
                                <Tooltip>
                                  <TooltipTrigger asChild>
                                    <Button
                                      variant="ghost"
                                      size="sm"
                                      className={`!px-0 !mx-0 ${actionButton}`}
                                      onClick={(e) => handleThreadAction("DOWNLOAD", thread, e)}
                                    >
                                      <Paperclip className="h-3 w-3 text-sahi-blue" />
                                    </Button>
                                  </TooltipTrigger>
                                  <TooltipContent>
                                    <p>Attachment</p>
                                  </TooltipContent>
                                </Tooltip>
                              )}
                              <ContactActions 
                                connectionData={thread?.connectionData} 
                                connID={thread.connID || thread.connectionData?.ConnID} 
                                stageID={thread?.currStageID}
                              />
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}

                    </TableBody>
                  </Table>
                </CardContent>
              </Card>

              {/* Pagination Component  */}
              <PaginationComp
                currentPage={currentPage}
                totalPages={totalPages}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(size) => setRowsPerPage(size)}
                onPageChange={(page) => setCurrentPage(page)}
              />

              {(() => {
                const salesOnlyMode = isSalesOnlyActive(threadTypes);
                const totalEntries = filteredThreads.length;

                if (salesOnlyMode && totalEntries <= 5 && userRights?.addThr) {
                  return (
                    <div className="flex items-center gap-3 pt-4">
                      <ThreadDropdown
                        onThreadTypeSelect={handleThreadTypeSelect}
                        iconButton={false}
                        activeFilteredTypes={selectedFilters.types}
                      />

                      {(() => {
                        const selectedTypes = selectedFilters.types;

                        const getImportType = () => {
                          if (!selectedTypes || selectedTypes.length !== 1 || selectedTypes === getAllThreadTypesString()) {
                            return 1; // Default to Inquiry
                          }
                          return parseInt(selectedTypes);
                        };

                        if (!canShowImportInquiries()) return null;
                        const selectedTypeID = getImportType();

                        if (selectedTypeID === 1) {
                          return <Integrations buttonText="Import" threadInfo={{ ...threadTypeInfo, importType: "inquiry" }} />;
                        } else if (selectedTypeID === 2 && userRights?.addThr) {
                          return (
                            <>
                              <Button onClick={() => setOrderImportOpen(true)} className="button-config text-base sahi-primary-button flex items-center justify-center !py-[6px] !px-[10px]">
                                <Download className="h-5 w-5" />
                                <p>Import</p>
                              </Button>
                              <ImportThreadsExcel
                                open={orderImportOpen}
                                onClose={() => setOrderImportOpen(false)}
                                threadInfo={{ ...threadTypeInfo, importType: "order" }}
                                triggerButton={false}
                              />
                            </>
                          );
                        } else if (userRights?.addThr) {
                          return <Integrations buttonText="Import" threadInfo={{ ...threadTypeInfo, importType: "inquiry" }} />;
                        } else {
                          return null;
                        }
                      })()}
                    </div>
                  );
                }
                return null;
              })()}
            </>
          ))}
      </>
    );
  };

  //threadtype filter
  const filteredFlowGroups = {
    customer: threadTypes.filter((t) => t.Flow === "In"),
    supplier: threadTypes.filter((t) => t.Flow === "Out"),
  };

  // Handle Bulk Delete
  const handleBulkDelete = async () => {
    const selectedThreads = threads.filter(thread => thread.isChecked);

    if (selectedThreads.length === 0) {
      toast.error("Please select threads to delete");
      return;
    }

    // Check if all selected threads have the same typeID
    const threadTypes = [...new Set(selectedThreads.map(thread => thread.typeID))];

    if (threadTypes.length > 1) {
      toast.error("Please select same type of threads.");
      return;
    }

    // All validations passed - get the thread IDs
    const selectedIds = selectedThreads.map(t => t.threadID);

    try {
      let result = await bulkThreadActionAPI(selectedIds, 'DLT');
      if (!result.error) {
        // Update all state arrays to remove deleted threads
        const filterDeletedThreads = (threadArray) =>
          threadArray.filter(thread => !selectedIds.includes(thread.threadID));

        // Update all relevant state arrays
        setThreads(prevThreads => filterDeletedThreads(prevThreads));
        setFilteredThreads(prevFilteredThreads => filterDeletedThreads(prevFilteredThreads));
        setPreSearchThreads(prevPreSearchThreads => filterDeletedThreads(prevPreSearchThreads));
        setSourceThreads(prevSourceThreads => filterDeletedThreads(prevSourceThreads));

        // Clear the bulk delete selection
        setThreadDeleteBulkIDs([]);

        // Reset to first page if current page becomes empty
        const remainingThreadsCount = filteredThreads.length - selectedIds.length;
        const newTotalPages = Math.ceil(remainingThreadsCount / rowsPerPage);
        if (currentPage > newTotalPages && newTotalPages > 0) {
          setCurrentPage(newTotalPages);
        }

        toast.success(`${isInqOnlyMode ? 'Inquiries' : 'Threads'} deleted.`);
        return;
      }
      toast.error(result.message);
    } catch (error) {
      console.error(`Delete thread action API error:`, error);
      toast.error(error.message);
    }
  };

  const handleBulkReassign = async (selectedUserID, bulkIDs = null) => {
    try {
      const idsToReassign = bulkIDs || threadDeleteBulkIDs;
      const selectedCount = idsToReassign.length;

      if (!idsToReassign || idsToReassign.length === 0) {
        toast.error('Select Threads For Reassignment.');
        return;
      }

      const result = await bulkThreadActionAPI(idsToReassign, "ASGN", Number(selectedUserID));

      if (!result.error) {
        setThreads(prevThreads =>
          prevThreads.map(thread =>
            idsToReassign.includes(thread.threadID)
              ? { ...thread, pocUserID: Number(selectedUserID), pocUserName: getExecutiveName(Number(selectedUserID)), isChecked: false }
              : thread
          )
        );

        setFilteredThreads(prevFilteredThreads =>
          prevFilteredThreads.map(thread =>
            idsToReassign.includes(thread.threadID)
              ? { ...thread, pocUserID: Number(selectedUserID), pocUserName: getExecutiveName(Number(selectedUserID)), isChecked: false }
              : thread
          )
        );

        setPreSearchThreads(prevPreSearchThreads =>
          prevPreSearchThreads.map(thread =>
            idsToReassign.includes(thread.threadID)
              ? { ...thread, pocUserID: Number(selectedUserID), pocUserName: getExecutiveName(Number(selectedUserID)), isChecked: false }
              : thread
          )
        );

        setSourceThreads(prevSourceThreads =>
          prevSourceThreads.map(thread =>
            idsToReassign.includes(thread.threadID)
              ? { ...thread, POCUserID: Number(selectedUserID), isChecked: false }
              : thread
          )
        );

        // Clear the bulk selection
        setThreadDeleteBulkIDs([]);

        toast.success(`Reassigned ${selectedCount} ${selectedCount === 1 ? 'inquiry' : 'inquiries'}.`);
        return;
      }
      toast.error(result.message || 'Failed to reassign inquiries');
    } catch (error) {
      console.error('Reassign API error:', error);
      toast.error(error.message || 'Error reassigning inquiries');
    }
  };

  const handleBulkAssign = async (selectedUserID) => {
    const selectedThreads = threads.filter(thread => thread.isChecked);

    if (selectedThreads.length === 0) {
      toast.error("Please select threads to assign");
      return;
    }

    const selectedIds = selectedThreads.map(t => t.threadID);

    try {
      dispatch(setGlobalLoading(true));

      // Call your bulk assign API
      let result = await bulkThreadActionAPI(selectedIds, 'ASSIGN', selectedUserID);

      if (!result.error) {
        // Update threads with new assignment
        const updateThreadAssignment = (threadArray) =>
          threadArray.map(thread =>
            selectedIds.includes(thread.threadID)
              ? { ...thread, pocUserID: selectedUserID, pocUserName: getExecutiveName(selectedUserID), isChecked: false }
              : thread
          );

        setThreads(prevThreads => updateThreadAssignment(prevThreads));
        setFilteredThreads(prevFilteredThreads => updateThreadAssignment(prevFilteredThreads));
        setPreSearchThreads(prevPreSearchThreads => updateThreadAssignment(prevPreSearchThreads));
        setSourceThreads(prevSourceThreads => updateThreadAssignment(prevSourceThreads));

        // Clear the bulk selection
        setThreadDeleteBulkIDs([]);

        toast.success(`${selectedThreads.length} ${selectedThreads.length === 1 ? getThreadTypeName(true, tempFilters.types, threadTypes, true) : getThreadTypeName(false, tempFilters.types, threadTypes, true)} assigned.`);
        return;
      }
      toast.error(result.message);
    } catch (error) {
      console.error(`Assign thread action API error:`, error);
      toast.error(error.message);
    } finally {
      dispatch(setGlobalLoading(false));
    }
  };

  //Component for mode selection
  // const ThreadMode = () => {
  //   return (
  //     <Popover open={open} onOpenChange={setOpen}>
  //       <PopoverTrigger asChild>
  //         <Button
  //           aria-expanded={open}
  //           variant="semidefault"
  //           className={cn("w-auto max-w-[220px] bg-white justify-between text-black sahi-radius border-sahi-green !h-8 lg:!h-10",
  //             modeValue && modeValue !== "all" && "bg-[#0b5d1e24] ")}
  //         >
  //           <span className="truncate font-normal">{modeValue}</span>
  //           <ChevronsUpDown className="ml-2 h-4 w-4 opacity-50" />
  //         </Button>
  //       </PopoverTrigger>
  //       <PopoverContent
  //         side="bottom"
  //         align="start"
  //         sideOffset={6}
  //         className="p-1 w-[7.5vw] min-w-[120px] bg-white">
  //         {options.map(option => (
  //           <div
  //             key={option}
  //             onClick={() => {
  //               setParamConnID('')
  //               setParamStage('all')
  //               setModeValue(option);
  //               setOpen(false);
  //             }}
  //             className={cn(
  //               "cursor-pointer px-3 py-2 sahi-radius text-sm hover:bg-gray-100 f-row items-center justify-between",
  //               modeValue === option && "bg-gray-200 font-medium"
  //             )}
  //           >
  //             {option}
  //             <Check className={cn("ml-auto h-4 w-4",
  //               modeValue === option ? "opacity-100" : "opacity-0"
  //             )} />
  //           </div>
  //         ))}
  //       </PopoverContent>
  //     </Popover>
  //   )
  // }

  // const ThreadTypeFilterMobile = () => {

  //   // Get current selected type for display
  //   const getSelectedTypeName = () => {
  //     const types = selectedFilters.types;

  //     // If "123456" (all types) or empty, show "All"
  //     if (!types || types === "123456") {
  //       return "All";
  //     }

  //     // Find the selected type
  //     const selectedType = threadTypes.find(type => type.TID.toString() === types);
  //     return selectedType ? selectedType.Typ : "All";
  //   };

  //   const handleTypeSelection = (typeID) => {
  //     if (typeID === 0) {
  //       // "All" selected
  //       setSelectedFilters(prev => ({
  //         ...prev,
  //         stage: "all",
  //         types: "123456"
  //       }));
  //       setTempFilters(prev => ({
  //         ...prev,
  //         stage: "all",
  //         types: "123456"
  //       }));
  //     } else {
  //       // Single type selected
  //       setSelectedFilters(prev => ({
  //         ...prev,
  //         types: typeID.toString()
  //       }));
  //       setTempFilters(prev => ({
  //         ...prev,
  //         types: typeID.toString()
  //       }));
  //     }
  //     setIsTypePopoverOpen(false);
  //   };

  //   // Create options with "All" first, then thread types
  //   const typeOptions = [
  //     { TID: 0, Typ: "All" },
  //     ...threadTypes
  //   ];

  //   return (
  //     <Popover open={isTypePopoverOpen} onOpenChange={setIsTypePopoverOpen}>
  //       <PopoverTrigger asChild>
  //         <Button
  //           variant="semidefault"
  //           className="w-auto max-w-[220px] bg-white justify-between text-black sahi-radius border-sahi-green bg-[#0b5d1e24] !h-8"
  //         >
  //           <span className="truncate font-normal">{getSelectedTypeName()}</span>
  //           <ChevronsUpDown className="ml-2 h-4 w-4 opacity-50" />
  //         </Button>
  //       </PopoverTrigger>
  //       <PopoverContent
  //         side="bottom"
  //         align="start"
  //         sideOffset={6}
  //         className="p-1 w-auto min-w-[160px] bg-white"
  //       >
  //         {typeOptions.map(option => (
  //           <div
  //             key={option.TID}
  //             onClick={() => handleTypeSelection(option.TID)}
  //             className={cn(
  //               "cursor-pointer px-3 py-2 sahi-radius text-sm hover:bg-gray-100 f-row items-center justify-between",
  //               (option.TID === 0 && selectedFilters.types === "123456") ||
  //                 (option.TID !== 0 && selectedFilters.types === option.TID.toString())
  //                 ? "bg-gray-200 font-medium" : ""
  //             )}
  //           >
  //             <div className="f-row items-center gap-2">
  //               {option.TID !== 0 && (
  //                 <ThreadSahiIcon tID={option.TID} className="h-4 w-4" />
  //               )}
  //               <span className="truncate">{option.Typ}</span>
  //             </div>
  //             <Check
  //               className={cn(
  //                 "ml-auto h-4 w-4",
  //                 (option.TID === 0 && selectedFilters.types === "123456") ||
  //                   (option.TID !== 0 && selectedFilters.types === option.TID.toString())
  //                   ? "opacity-100" : "opacity-0"
  //               )}
  //             />
  //           </div>
  //         ))}
  //       </PopoverContent>
  //     </Popover>
  //   );
  // };

  //Component for thread fileter type wise
  //Component for thread fileter type wise
  const ThreadTypeFilterDesktop = () => {
    const typesStr = selectedFilters.types?.toString();
    const userRights = checkUserRights();

    const activeThreadTypes = threadTypes.filter(t => t.Sh === true);

    if (activeThreadTypes.length === 1) {
      return null;
    }

    const toggleTypeFilter = (tID) => {
      const tIDStr = tID.toString();
      setSelectedFilters((prev) => {
        const updated = typesStr.includes(tIDStr) ? typesStr.replace(tIDStr, "") : typesStr + tIDStr;
        return { ...prev, types: updated, stage: "all" };
      });
      setTempFilters((prev) => {
        const updated = typesStr.includes(tIDStr) ? typesStr.replace(tIDStr, "") : typesStr + tIDStr;
        return { ...prev, types: updated, stage: "all" };
      });
    };

    // Determine which groups to show based on user rights
    const getVisibleGroups = () => {
      const groups = [];
      if (userRights.canSeeCstrs) {
        groups.push("customer");
      }
      if (userRights.canSeeSplrs) {
        groups.push("supplier");
      }
      return groups;
    };

    const visibleGroups = getVisibleGroups();

    return (
      <div className="flex flex-wrap gap-4">
        {visibleGroups.map((groupKey) => {
          const label = groupKey === "customer" ? "Opportunities :" : "Supply Chain :";
          const options = filteredFlowGroups[groupKey];
          if (options.length === 0) return null;
          const groupTIDs = options.map((t) => t.TID.toString());

          return (
            <Button
              key={groupKey}
              variant="semidefaultcol"
              className={cn(
                "w-auto  bg-white text-black sahi-radius px-3 py-2",
                "filter-border",
                "flex flex-row items-center align-middle"
              )}
            >
              {/* Header */}
              <div className="flex items-center gap-2 ">
                <label className="f-row items-center gap-2 cursor-pointer">
                  <span className="font-meduim text-sm">{label}</span>
                </label>
              </div>

              <div className="flex flex-wrap items-center gap-1">
                {options.map((t) => (
                  <label
                    key={t.TID}
                    className="flex items-center gap-1 cursor-pointer sahi-radius px-2 py-1"
                  >
                    <Checkbox
                      checked={typesStr.includes(t.TID.toString())}
                      onCheckedChange={() => toggleTypeFilter(t.TID)}
                      className={checkBoxCss}
                    />
                    <div className="ml-1 f-row gap-1 items-center align-middle">
                      <ThreadSahiIcon tID={t.TID} className="h-4 w-4 " />
                      <span className="text-sm font-normal text-black">
                        {t.Sn || ""}
                      </span>
                    </div>
                  </label>
                ))}
              </div>
            </Button>
          );
        })}
      </div>
    );
  };

  const ConnTypeFilterDesktop = () => {
    if (!isInqOnlyMode || selectedFilters.types !== "1") {
      return null;
    }

    const connTypeOptions = [
      { name: "Future Prospects", value: "P" },
      { name: "Existing Customers", value: "C" }
    ];

    const handleConnTypeToggle = (value) => {
      const currentTypes = selectedFilters.connType;

      let newValue;

      // If currently "all" (both selected/showing all)
      if (currentTypes === "all") {
        newValue = value === "P" ? "C" : "P";
      }
      else if (currentTypes.includes(value)) {
        // Remove this type
        newValue = currentTypes.replace(value, "");
      }
      // Add this type
      else {
        // If currently empty, just add this value
        if (currentTypes === "") {
          newValue = value;
        } else {
          newValue = currentTypes + value;
          // Sort to maintain consistent order
          newValue = [...newValue].sort().join("");
          // If both are now selected, set to "all"
          if (newValue === "CP" || newValue === "PC") {
            newValue = "all";
          }
        }
      }

      setSelectedFilters((prev) => ({
        ...prev,
        connType: newValue
      }));
      setTempFilters((prev) => ({
        ...prev,
        connType: newValue
      }));
    };

    return (
      <Button
        variant="semidefaultcol"
        className={cn(
          "w-auto bg-white text-black sahi-radius px-3 py-2",
          "filter-border",
          "flex flex-row items-center align-middle"
        )}
      >
        <div className="flex items-center gap-2">
          <label className="f-row items-center gap-2 cursor-pointer">
            <span className="font-medium text-sm">Connection Type:</span>
          </label>
        </div>

        <div className="flex flex-wrap items-center gap-1">
          {connTypeOptions.map((option) => (
            <label
              key={option.value}
              className="flex items-center gap-1 cursor-pointer sahi-radius px-2 py-1"
            >
              <Checkbox
                checked={
                  selectedFilters.connType === "all" ||
                  selectedFilters.connType.includes(option.value)
                }
                onCheckedChange={() => handleConnTypeToggle(option.value)}
                className={checkBoxCss}
              />
              <span className="text-sm font-normal text-black">
                {option.name}
              </span>
            </label>
          ))}
        </div>
      </Button>
    );
  };

  const StageExpiryFilterDesktop = () => {
    return (
      <Button
        variant="semidefaultcol"
        className={cn(
          "w-auto bg-white text-black sahi-radius px-3 py-2",
          "filter-border",
          "flex flex-row items-center align-middle gap-2"
        )}
      >
        <label className="flex items-center gap-2 cursor-pointer">
          <Checkbox
            checked={selectedFilters.stageExpiry === true}
            onCheckedChange={(checked) => {
              setSelectedFilters((prev) => ({
                ...prev,
                stageExpiry: checked
              }));
              setTempFilters((prev) => ({
                ...prev,
                stageExpiry: checked
              }));
            }}
            className={checkBoxCss}
          />
          <span className="text-sm font-normal text-black whitespace-nowrap">
            {isInqOnlyMode ? "Inquiries" : "Threads"} stuck at stage
          </span>
        </label>
      </Button>
    );
  };

  const renderAddThreadButtonMobile = () => {
    const label =
      threadTypeInfo.typeID === 0
        ? "Enter"
        : `Add ${threadTypeInfo.typeID === 1 && isInqOnlyMode ? threadTypeInfo.snSng : threadTypeInfo.typeNameSng || "Record"}`;

    return (currentThreads.length <= 4) && userRights?.addThr ? (
      <div className="flex flex-col sm:flex-row gap-2 mt-2">
        {threadTypeInfo.typeID === 0 ? (
          <ThreadDropdown
            onThreadTypeSelect={handleThreadTypeSelect}
            iconButton={false}
            activeFilteredTypes={selectedFilters.types}
            className=""
          />
        ) : (
          <div className="flex flex-row flex-wrap gap-2">
            <Button
              onClick={() => handleThreadTypeSelect(threadTypeInfo.typeID)}
            >
              <Plus className="h-4 w-4" />
              {label || "Add Thread"}
            </Button>
            {isInqOnlyMode && userRights?.addThr && canShowImportInquiries() && (
              <Integrations
                triggerButton={false}
                buttonText="Import Inquiries"
                threadInfo={{ ...threadTypeInfo, importType: "inquiry" }}
                open={integrationsOpen}
                onOpenChange={setIntegrationsOpen}
              />
            )}
            {isInqOnlyMode && userRights?.addThr && canShowImportInquiries() && (
              <Button
                onClick={() => setIntegrationsOpen(true)}
              >
                <FaDownload className="h-4 w-4" />
                Import Inquiries
              </Button>
            )}
            {threadDeleteBulkIDs.length > 0 && isBulkAllowed && (
              <div className="flex items-center gap-2">
                <Button
                  onClick={() => setBulkWhatsAppDialogOpen(true)}
                >
                  <BsWhatsapp className="h-4 w-4" />
                  Bulk
                </Button>
              </div>
            )}
          </div>
        )
        }

      </div>
    ) : null;
  };

  const filterButton = useMemo(() => {
    let activeFilterClass = isFilterSelected && !isMobile ? "filter-active" : "";
    let filterIconToggleClass = "h-4 w-4 " + (isMobile ? "" : (isFilterSelected ? "text-sahi-primary-color" : "text-white group-hover:text-sahi-primary-color"));

    return (
      <Button
        className={cn(filterBtn, activeFilterClass, "relative")}
        onClick={() => setIsFilterSelected(true)}
        aria-label="Toggle Filter"
      >
        <div className="h-6 w-6 flex items-center justify-center transition-all">
          <Filter
            className={cn(filterIconToggleClass)}
          />
        </div>
        {hasActiveFilters && (
          <span className="absolute -top-1 -right-1 h-2.5 w-2.5 bg-sahi-green rounded-full border border-sahi-white" />
        )}
      </Button>
    )
  }, [isFilterSelected, isMobile, selectedFilters]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader2 className="h-8 w-8 animate-spin text-sahi-primary-color mr-3" />
        <span className="text-text-color">{`Loading ${threadTypes[threadTypeInfo.typeID - 1]?.Typ ?? ""})}`}</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        <Card className="border-sahi-red bg-red-50">
          <CardContent className="p-4">
            <p className="text-sahi-red font-medium">{error}</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  const selectedThreadsData = threads.filter(thread =>
    threadDeleteBulkIDs.includes(thread.threadID)
  );

  return (
    <TooltipProvider>
      <div className={`${embedded ? 'space-y-1' : 'space-y-3 lg:space-y-6'} ${hasActiveFilters ? '' : 'overflow-x-hidden'}`}>

        {/*--------------- Header ------------*/}
        {/* Web Layout */}
        <div className="hidden lg:flex justify-between items-center gap-3">
          <div className="flex items-center justify-between flex-grow">
            {/* Left Side: Title */}
            <div className="flex flex-col mr-4">
              <h1 className="text-3xl font-bold text-text-color web-header-name">
                {threadTypeInfo.typeName || "Threads"}
              </h1>
              {/* {!isMobile &&
                <span className="text-xs mt-1 text-gray-600 leading-relaxed whitespace-nowrap">Track specific requests and potential orders linked to your contacts.</span>
                } */}
            </div>



            {!isThreadsEmpty() && (
              <div className="flex items-center gap-3">
                {/* Total Summary Box */}
                <div
                  variant="noHoversemidefault"
                  className={cn(
                    "flex items-center px-3 lg:px-4 h-8 lg:h-10",
                    "w-fit max-w-[240px] bg-white text-black rounded-lg border filter-border shadow-sm"
                  )}
                >
                  <span className="f-row gap-1 whitespace-nowrap text-xs lg:text-sm">
                    <span>Total: </span>
                    <span className="font-medium">{typeFilteredCount}</span>
                  </span>
                </div>

                {/* Selected Count Box */}
                {getSelectedCountAll() > 0 && (
                  <div
                    className={cn(
                      "flex items-center px-3 lg:px-4 h-8 lg:h-10",
                      "w-fit max-w-[240px] bg-white text-black rounded-lg border filter-border shadow-sm"
                    )}
                  >
                    <span className="f-row gap-1 whitespace-nowrap text-xs lg:text-sm">
                      <span>Selected: </span>
                      <span className="font-medium">{getSelectedCountAll()}</span>
                    </span>
                  </div>
                )}

                {/* Search Box */}
                <div className="relative w-120 filter-border">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-dropdown-white" />
                  <Input
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => { setSearchTerm(e.target.value) }}
                    className="pl-10 h-10 border-none focus:outline-none focus:ring-0 shadow-none"
                  />
                </div>
              </div>
            )}
          </div>
          <div className="flex items-center gap-3">
            {/* Multi-Type Import Button - Always Visible */}
            {(() => {
              const selectedTypes = selectedFilters.types;

              const getImportType = () => {
                if (!selectedTypes || selectedTypes.length !== 1 || selectedTypes === getAllThreadTypesString()) {
                  return 1;
                }
                return parseInt(selectedTypes);
              };

              if (!canShowImportInquiries()) return null;
              const selectedTypeID = getImportType();

              if (selectedTypeID === 1 && userRights?.addThr) {
                return <Integrations buttonText="Import" threadInfo={{ ...threadTypeInfo, importType: "inquiry" }} />;
              } else if (selectedTypeID === 2 && userRights?.addThr) {
                return (
                  <>
                    <Button onClick={() => setOrderImportOpen(true)} variant="additional">
                      <FaDownload className="h-5 w-5" />
                      <p>Import</p>
                    </Button>
                    <ImportThreadsExcel
                      open={orderImportOpen}
                      onClose={() => setOrderImportOpen(false)}
                      threadInfo={{ ...threadTypeInfo, importType: "order" }}
                      triggerButton={false}
                    />
                  </>
                );
              } else if (userRights?.addThr) {
                return <Integrations buttonText="Import" threadInfo={{ ...threadTypeInfo, importType: "inquiry" }} />;
              } else {
                return null;
              }
            })()}

            {/* Column Preferences Dropdown */}
            {filteredThreads.length > 0 && <ColumnPreferencesDropdown
              type="THR"
              columns={threadTableHeadersData.filter(c => c.key !== 'checkbox_col' && c.key !== 'type')}
              columnVisibility={columnVisibility}
              onUpdate={(newVisibility) => setColumnVisibility(newVisibility)}
            />}

            {/* Kanban View Button */}
            <Button
              onClick={() => {
                const currentParams = new URLSearchParams(location.search);
                // If a specific thread type is selected, pass it as tid
                const selectedTypes = selectedFilters.types.split('').map(t => parseInt(t));

                if (selectedTypes.length === 1) {
                  currentParams.set('tid', selectedFilters.types);
                } else {
                  currentParams.delete('tid');
                }
                navigate(`/kanban?${currentParams.toString()}`);
              }}
              className="button-config text-base sahi-primary-button flex items-center py-[6px] px-[10px]"
            >
              <BsViewStacked className="h-4 w-4" />
              Kanban View
            </Button>

            <Button
              onClick={() => {
                const currentParams = new URLSearchParams(location.search);
                // If a specific thread type is selected, pass it as tid
                const selectedTypes = selectedFilters.types.split('').map(t => parseInt(t));

                navigate(`/threads-detail`);
              }}
              className="button-config text-base sahi-primary-button flex items-center py-[6px] px-[10px]"
            >
              <FaExpandAlt className="h-4 w-4" />
              Expand
            </Button>

            {/* Commitment View Button */}
            {!isInqOnlyMode &&
              <Button
                onClick={() => {
                  const currentParams = new URLSearchParams(location.search);
                  // If a specific thread type is selected, pass it as tid
                  // const selectedTypes = selectedFilters.types.split('').map(t => parseInt(t));

                  // if (selectedTypes.length === 1) {
                  //   currentParams.set('tid', selectedFilters.types);
                  // } else {
                  //   currentParams.delete('tid');
                  // }
                  navigate(`/commitment-view?${currentParams.toString()}`);
                }}
                className="button-config text-base sahi-primary-button flex items-center py-[6px] px-[10px]"
              >
                <LuCalendarClock className="!h-5 !w-5" />
                Commitment View
              </Button>
            }
            {/* Add Threads */}
            {userRights?.addThr && (
              <ThreadDropdown
                className="text-base"
                onThreadTypeSelect={handleThreadTypeSelect}
                iconButton={false}
                activeFilteredTypes={selectedFilters.types}
              />
            )}

            <AlertDialog
              open={deleteAlertOpen}
              onOpenChange={setDeleteAlertOpen}
            >
              <AlertDialogTrigger asChild>
                {getSelectedCountAll() != 0 && <Button
                  className="button-config text-base sahi-primary-button flex items-center py-[6px] px-[10px]"
                >
                  <Trash2 className="h-4 w-4" />
                  Delete
                </Button>}
              </AlertDialogTrigger>
              <AlertDialogContent>
                <AlertDialogHeader>
                  <AlertDialogTitle>
                    {`Are you sure you wish to delete the selected ${threadDeleteBulkIDs.length == 1 ? getThreadTypeName(true, tempFilters.types, threadTypes, false) : getThreadTypeName(false, tempFilters.types, threadTypes, false)}?`}
                  </AlertDialogTitle>
                  <AlertDialogDescription>
                    {`This action cannot be undone. This will permanently delete the selected ${threadDeleteBulkIDs.length == 1 ? getThreadTypeName(true, tempFilters.types, threadTypes, false) : getThreadTypeName(false, tempFilters.types, threadTypes, false)}.`}
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="!justify-start gap-3">
                  <Button
                    onClick={() => { handleBulkDelete(); setDeleteAlertOpen(false); }}
                    className={`sahi-primary-button flex-1 sm:flex-none sm:min-w-[120px]`}
                  >
                    <Check className="w-3 h-3" />
                    Delete {threadDeleteBulkIDs.length} {threadDeleteBulkIDs.length == 1 ? getThreadTypeName(true, tempFilters.types, threadTypes, true) : getThreadTypeName(false, tempFilters.types, threadTypes, true)}
                  </Button>
                  <Button
                    variant="outline"
                    onClick={() => { setDeleteAlertOpen(false); }}
                    className={`sahi-secondary-button flex-1 sm:flex-none sm:min-w-[100px]`}
                  >
                    <X className="w-3 h-3" />
                    Close
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>

            {selectedFilters.types === "1" && getSelectedCountAll() > 0 && (
              <Button
                className="button-config text-base sahi-primary-button flex items-center py-[6px] px-[10px]"
                onClick={() => setReassignDialogOpen(true)}
              >
                <UserCheck className="h-4 w-4" />
                Reassign
              </Button>
            )}

            {getSelectedCountAll() > 0 && isBulkAllowed && (
              <Button
                className="button-config text-base sahi-primary-button flex items-center py-[6px] px-[10px]"
                onClick={() => setBulkWhatsAppDialogOpen(true)}
              >
                <BsWhatsapp className="h-4 w-4" />
                Bulk
              </Button>
            )}

            {!isThreadsEmpty() && (
              <Button
                className={cn(
                  "button-config sahi-primary-button flex items-center justify-center group px-2.5 py-[5px] ",
                  isFilterSelected && "filter-active"
                )}
                onClick={() => setIsFilterSelected(prev => !prev)}
                aria-label="Toggle filter"
              >
                <div className="h-6 w-6 flex items-center justify-center transition-all">
                  <Filter
                    className={cn(
                      "h-4 w-4",
                      isFilterSelected
                        ? "text-sahi-primary-color"
                        : "text-white group-hover:text-sahi-primary-color"
                    )}
                  />
                </div>
              </Button>
            )}
            {!isInqOnlyMode && selectedFilters.types && selectedFilters.types.length === 1 && (
              <Button
                onClick={() => {
                  window.open(`/Web/threads-report?tID=${selectedFilters.types}`, '_blank');
                }}
                variant="secondary"
              >
                <div className="h-6 w-6 flex items-center justify-center transition-all">
                  <History className="h-4 w-4" />
                </div>
              </Button>
            )}

            {isInqOnlyMode && (
              <Button
                onClick={() => {
                  window.open(`/Web/threads-report?tID=1`, '_blank');
                }}
                variant="secondary"
              >
                <div className="h-6 w-6 flex items-center justify-center transition-all">
                  <History className="h-4 w-4" />
                </div>
              </Button>
            )}

          </div>

        </div>
        {/* Mobile view */}
        {!embedded && (
          <div className="f-col lg:hidden gap-3 ">
            {/* Search */}
            {!isThreadsEmpty() && (
              <div className="w-full flex items-center gap-2">
                <div className="relative flex-grow">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-dropdown-white" />
                  <Input
                    placeholder={`Search`}
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      applyFilters();
                    }}
                    className="pl-10 h-10 w-full"
                  />
                </div>
                {filterButton}
              </div>
            )}
          </div>
        )}

        {/*--------------- Thread type Filter (Type/Status) ------------*/}
        {!isMobile && (
          <div className={`f-row flex-wrap gap-4 ${getSelectedCountOnCurrentPage() > 0} ? 'lg:hidden' : 'hidden'`}>
            <ThreadTypeFilterDesktop />
            {isFilterSelected && <ConnTypeFilterDesktop />}
          </div>
        )}

        {/*--------------- Filter ------------*/}
        {isFilterSelected &&
          (isMobile ? (
            <Drawer open={isDrawerOpen}
              onOpenChange={() => {
                setIsDrawerOpen()
                setIsFilterSelected(false)
              }}>
              <DrawerContent className="p-0 [&>div:first-child]:hidden">
                <div className="f-col h-[100dvh] !rounded-t-[10px]">
                  {/* Header */}
                  <div className="flex plain items-center justify-between p-4 border-b-2 border-gray-200 text-xl !rounded-t-[10px]">
                    <div className="flex gap-4 items-center ">
                      <DrawerClose tabIndex={-1} className="p-0 w-auto h-auto flex-shrink-0 flex justify-center">
                        <ArrowLeft className="h-[24px] w-[24px]" onClick={handleCancel} />
                        <span className="sr-only">Back</span>
                      </DrawerClose>
                      <p className="text-lg font-semibold text-sahi-primary-color">{isInqOnlyMode ? "Inquiry Filters" : "Thread Filters"}</p>
                    </div>

                    <button
                      className="group flex items-center gap-1 text-sm font-light  hover:underline transition duration-200  text-sahi-primary-color"
                      onClick={() => {
                        handleResetFilters()
                        setIsFilterSelected(false)
                      }}
                    >
                      <RiResetLeftFill className="group-hover:rotate-[-20deg] transition-transform duration-200" />
                      <span>Reset</span>
                    </button>
                  </div>
                  {/* Main Content */}
                  <div className="flex flex-1 overflow-y-auto">
                    {/* Scrollable Filters */}
                    <div className="flex-1 p-3 overflow-y-auto filter-scroll-container">
                      {[
                        ...(() => {
                          const activeThreadTypes = threadTypes.filter(t => t.Sh === true);
                          // Only include types filter if more than one thread type is active
                          if (activeThreadTypes.length > 1) {
                            return [filterOptions[0]]; // Thread types filter
                          }
                          return [];
                        })(),
                        ...filterOptions.slice(1, 7), // Include connID, assignedTo, stage, category, connType, dateRange (indices 1-6)
                      ].filter(Boolean).filter(filter => {
                        // Hide category filter if no categories available
                        if (filter.key === 'category' && availableCategories.length === 0) {
                          return false;
                        }
                        // Don't render otherMonth, otherQuarter, otherYear in main mapping - they're in conditional blocks
                        if (['otherMonth', 'otherQuarter', 'otherYear'].includes(filter.key)) {
                          return false;
                        }
                        if (filter.key === 'dateRange') {
                          return false;
                        }
                        return true;
                      }).map(({ key, label, options, displayValue, type, mobiledisabled, mobileDropdownText, MobileLabel, showAllOption, showAllOptionNum, searchEnabled }) => (
                        <div key={key} id={key} className="mb-4 w-full">
                          <DrawerFilter
                            key={key}
                            id={key}
                            label={label}
                            options={options}
                            value={tempFilters[key]}
                            displayValue={displayValue}
                            onChange={(value) => {
                              setTempFilters((prev) => ({
                                ...prev,
                                [key]: value,
                                ...(key === 'dateRange' && {
                                  otherMonth: "all",
                                  otherQuarter: "all",
                                  otherYear: "all",
                                  fromDate: null,
                                  toDate: null
                                })
                              }));
                            }}
                            disabled={mobiledisabled}
                            sortConfig={sortConfig}
                            setTempsortConfig={setTempsortConfig}
                            tempsortConfig={tempsortConfig}
                            sortOptionMap={sortKeyMapMobileFilter}
                            type={type}
                            mobileDropdownText={mobileDropdownText}
                            MobileLabel={MobileLabel}
                            showAllOption={showAllOption}
                            showAllOptionNum={showAllOptionNum}
                            searchEnabled={searchEnabled}
                          />
                        </div>
                      ))}

                      {/* Date Range and Secondary Filters Wrapper */}
                      <div className="flex flex-row gap-3 w-full">
                        {/* Period Dropdown */}
                        {(() => {
                          const isMonthVisible = tempFilters.dateRange === "Other Month";
                          const isQuarterVisible = tempFilters.dateRange === "Other Quarter";
                          const isYearVisible = tempFilters.dateRange === "Other Year";
                          const hasSecondaryDropdown = isMonthVisible || isQuarterVisible || isYearVisible;
                          const periodWidth = hasSecondaryDropdown ? 'w-1/2' : 'w-full';
                          const dateRangeFilter = filterOptions.find(f => f.key === 'dateRange');

                          return (
                            <div className={`${periodWidth}`}>
                              <DrawerFilter
                                id="dateRange"
                                label={dateRangeFilter.label}
                                options={dateRangeFilter.options}
                                value={tempFilters.dateRange}
                                displayValue={dateRangeFilter.displayValue}
                                onChange={(value) => {
                                  setTempFilters((prev) => ({
                                    ...prev,
                                    dateRange: value,
                                    otherMonth: "all",
                                    otherQuarter: "all",
                                    otherYear: "all",
                                    fromDate: null,
                                    toDate: null
                                  }));
                                }}
                                type={dateRangeFilter.type}
                                mobileDropdownText={dateRangeFilter.mobileDropdownText}
                                MobileLabel={dateRangeFilter.MobileLabel}
                                searchEnabled={dateRangeFilter.searchEnabled}
                              />
                            </div>
                          );
                        })()}

                        {/* Other Month Filter */}
                        {tempFilters.dateRange === "Other Month" && (
                          <div className="w-1/2">
                            <DrawerFilter
                              id="otherMonth"
                              label={filterOptions.find(f => f.key === "otherMonth")?.label}
                              options={filterOptions.find(f => f.key === "otherMonth")?.options}
                              value={tempFilters.otherMonth}
                              onChange={(value) => {
                                setTempFilters((prev) => ({
                                  ...prev,
                                  otherMonth: value,
                                  fromDate: null,
                                  toDate: null
                                }));
                              }}
                              type="list"
                              MobileLabel="Month"
                              searchEnabled={true}
                              displayValue={(val) => val}
                              showAllOption={false}
                            />
                          </div>
                        )}

                        {/* Other Quarter Filter - shows when "Other Quarter" is selected */}
                        {tempFilters.dateRange === "Other Quarter" && (
                          <div className="w-1/2">
                            <DrawerFilter
                              id="otherQuarter"
                              label={filterOptions.find(f => f.key === "otherQuarter")?.label}
                              options={filterOptions.find(f => f.key === "otherQuarter")?.options}
                              value={tempFilters.otherQuarter}
                              onChange={(value) => {
                                setTempFilters((prev) => ({
                                  ...prev,
                                  otherQuarter: value,
                                  fromDate: null,
                                  toDate: null
                                }));
                              }}
                              type="list"
                              MobileLabel="Select Quarter"
                              searchEnabled={true}
                              displayValue={(val) => val}
                              showAllOption={false}
                            />
                          </div>
                        )}

                        {/* Other Year Filter - shows when "Other Year" is selected */}
                        {tempFilters.dateRange === "Other Year" && (
                          <div className="w-1/2">
                            <DrawerFilter
                              id="otherYear"
                              label={filterOptions.find(f => f.key === "otherYear")?.label}
                              options={filterOptions.find(f => f.key === "otherYear")?.options}
                              value={tempFilters.otherYear}
                              onChange={(value) => {
                                setTempFilters((prev) => ({
                                  ...prev,
                                  otherYear: value,
                                  fromDate: null,
                                  toDate: null
                                }));
                              }}
                              type="list"
                              MobileLabel="Select Year"
                              searchEnabled={true}
                              displayValue={(val) => val}
                              showAllOption={false}
                            />
                          </div>
                        )}
                      </div>

                      {/* Date Range Pickers for Other Month */}
                      {tempFilters.dateRange === "Other Month" && tempFilters.otherMonth !== "all" && (() => {
                        const monthParts = tempFilters.otherMonth.split(" ");
                        const monthYear = monthParts.length === 2 ? `${monthParts[0]} ${monthParts[1]}` : null;
                        const firstDay = monthParts.length === 2 ? new Date(`${monthParts[0]} 1, ${monthParts[1]}`) : null;
                        const lastDay = monthParts.length === 2 ? (() => {
                          const date = new Date(`${monthParts[0]} 1, ${monthParts[1]}`);
                          date.setMonth(date.getMonth() + 1);
                          date.setDate(0);
                          return date;
                        })() : null;

                        return (
                          <div className="mb-4">
                            {/* <label className="text-sm font-medium text-text-color block mb-2">Date Range</label> */}
                            <div className={`flex items-center ${isMobile ? "mt-2" : ""} gap-2`}>
                              <DatePicker
                                value={tempFilters.fromDate || ""}
                                onChange={(date) => {
                                  setTempFilters((prev) => ({ ...prev, fromDate: date }));
                                }}
                                placeholder="From"
                                disableFuture={false}
                                className="!space-y-0 !h-10 flex-1"
                                minDate={firstDay?.toISOString().split('T')[0]}
                                maxDate={lastDay?.toISOString().split('T')[0]}
                                disableMonthNavigation={true}
                                disableYearNavigation={true}
                                defaultMonth={monthYear}
                              />
                              <span className="text-text-color">to</span>
                              <DatePicker
                                value={tempFilters.toDate || ""}
                                onChange={(date) => {
                                  setTempFilters((prev) => ({ ...prev, toDate: date }));
                                }}
                                placeholder="To"
                                disableFuture={false}
                                className="!space-y-0 !h-10 flex-1"
                                minDate={firstDay?.toISOString().split('T')[0]}
                                maxDate={lastDay?.toISOString().split('T')[0]}
                                disableMonthNavigation={true}
                                disableYearNavigation={true}
                                defaultMonth={monthYear}
                              />
                            </div>
                          </div>
                        );
                      })()}

                      {/* Date Range Pickers for This Month */}
                      {tempFilters.dateRange === "This Month" && (() => {
                        const now = new Date();
                        const currentMonth = now.getMonth();
                        const currentYear = now.getFullYear();
                        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                        const monthYear = `${months[currentMonth]} ${currentYear}`;
                        const firstDay = new Date(currentYear, currentMonth, 1);
                        const lastDay = new Date(currentYear, currentMonth + 1, 0);

                        return (
                          <div className="mb-4">
                            {/* <label className="text-sm font-medium text-text-color block mb-2">Date Range</label> */}
                            <div className={`flex items-center ${isMobile ? "mt-2" : ""} gap-2`}>
                              <DatePicker
                                value={tempFilters.fromDate || ""}
                                onChange={(date) => {
                                  setTempFilters((prev) => ({ ...prev, fromDate: date }));
                                }}
                                placeholder="From"
                                disableFuture={false}
                                className="!space-y-0 !h-10 flex-1"
                                minDate={firstDay.toISOString().split('T')[0]}
                                maxDate={lastDay.toISOString().split('T')[0]}
                                disableMonthNavigation={true}
                                disableYearNavigation={true}
                                defaultMonth={monthYear}
                              />
                              <span className="text-text-color">to</span>
                              <DatePicker
                                value={tempFilters.toDate || ""}
                                onChange={(date) => {
                                  setTempFilters((prev) => ({ ...prev, toDate: date }));
                                }}
                                placeholder="To"
                                disableFuture={false}
                                className="!space-y-0 !h-10 flex-1"
                                minDate={firstDay.toISOString().split('T')[0]}
                                maxDate={lastDay.toISOString().split('T')[0]}
                                disableMonthNavigation={true}
                                disableYearNavigation={true}
                                defaultMonth={monthYear}
                              />
                            </div>
                          </div>
                        );
                      })()}

                      <div className="mb-4">
                        <DrawerFilter
                          id="sort"
                          label="Sort by"
                          options={["Due (oldest first)", "Received (newest first)", "Next action (oldest first)", "Received (oldest first)", "Amount (highest first)"]}
                          value={tempsortConfig?.key ? `${tempsortConfig.key}-${tempsortConfig.direction}` : ""}
                          onChange={(value) => {
                          }}
                          sortConfig={sortConfig}
                          setTempsortConfig={setTempsortConfig}
                          tempsortConfig={tempsortConfig}
                          sortOptionMap={sortKeyMapMobileFilter}
                          type="sort"
                          MobileLabel="Sort by"
                        />
                      </div>

                      {/* <div className="mb-4">
                        <label className="flex items-center cursor-pointer select-none gap-2">
                          <input
                            type="checkbox"
                            id="selectDateFilterCheckboxMobile"
                            checked={tempFilters.selectDate}
                            onChange={(e) => {
                              setTempFilters((prev) => ({
                                ...prev,
                                selectDate: e.target.checked,
                                selectedDate: e.target.checked ? prev.selectedDate : null
                              }));
                            }}
                            className="h-4 w-4 rounded border-gray-300 filter-border text-sahi-primary-color focus:ring-sahi-primary-color"
                          />
                          <span className="text-sm font-medium text-text-color">Select Date</span>
                        </label>

                        {tempFilters.selectDate && (
                          <DatePicker
                            value={tempFilters.selectedDate || ""}
                            onChange={(date) => {
                              let dateStr = null;
                              if (date) {
                                const dateObj = new Date(date);
                                const year = dateObj.getFullYear();
                                const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                                const day = String(dateObj.getDate()).padStart(2, '0');
                                dateStr = `${year}-${month}-${day}`;
                              }
                              setTempFilters((prev) => ({ ...prev, selectedDate: dateStr }));
                            }}
                            placeholder="Select date"
                            disableFuture={false}
                            className="!space-y-0 mt-3 w-1/2"
                          />
                        )}
                      </div> */}
                    </div>
                  </div>
                  {/* Always Visible Footer */}
                  <DrawerFooter className="sticky bottom-0 border-t-2 p-3 bg-sahi-white">
                    <DrawerClose>
                      <div className="f-row justify-start gap-2">
                        <Button
                          className="sahi-primary-button"
                          onClick={() => {
                            setSelectedFilters(tempFilters);
                            setIsDrawerOpen(false);
                            setIsFilterSelected(false);
                            sortData(
                              tempsortConfig.key,
                              tempsortConfig.direction
                            );
                          }}
                        >
                          Apply
                        </Button>
                        <Button
                          variant="outline"
                          className="sahi-secondary-button"
                          onClick={handleCancel}
                        >
                          Cancel
                        </Button>
                      </div>
                    </DrawerClose>
                  </DrawerFooter>
                </div>
              </DrawerContent>
            </Drawer>
          ) : (
            <div className="hidden lg:flex flex-wrap gap-4">
              {[
                ...filterOptions.slice(1, 5),
              ].filter(filter => {
                // Hide category filter if no categories available
                if (filter.key === 'category' && availableCategories.length === 0) {
                  return false;
                }
                return true;
              }).map(({ key, label, options, displayValue, searchEnabled, disabled }) => (
                <CommonFilter
                  key={key}
                  label={label}
                  options={options}
                  value={selectedFilters[key]}
                  onChange={(value) => {
                    setSelectedFilters((prev) => ({ ...prev, [key]: value }));
                    setTempFilters((prev) => ({ ...prev, [key]: value }));
                  }}
                  searchEnabled={searchEnabled}
                  displayValue={displayValue}
                  disabled={disabled}
                />
              ))}

              {/* Period Filter */}
              <CommonFilter
                label={selectedFilters.dateRange === "all" ? "All Periods" : selectedFilters.dateRange}
                options={getDateRangeOptions().map(option => ({
                  name: option,
                  ID: option,
                }))}
                value={selectedFilters.dateRange}
                onChange={(value) => {
                  setSelectedFilters((prev) => ({
                    ...prev,
                    dateRange: value,
                    otherMonth: "all",
                    otherQuarter: "all",
                    otherYear: "all",
                    fromDate: null,
                    toDate: null
                  }));
                  setTempFilters((prev) => ({
                    ...prev,
                    dateRange: value,
                    otherMonth: "all",
                    otherQuarter: "all",
                    otherYear: "all",
                    fromDate: null,
                    toDate: null
                  }));
                }}
                searchEnabled={false}
                displayValue={(val) => val}
                showAllOption={false}
                hideAllOption={true}
              />

              {/* Other Month Filter - shows when "Other Month" is selected */}
              {selectedFilters.dateRange === "Other Month" && (
                <CommonFilter
                  label="Month"
                  options={getPastMonthOptions(oldestSinceDT).map(option => ({
                    name: option.name,
                    ID: option.ID,
                  }))}
                  value={selectedFilters.otherMonth}
                  onChange={(value) => {
                    setSelectedFilters((prev) => ({
                      ...prev,
                      otherMonth: value,
                      fromDate: null,
                      toDate: null
                    }));
                    setTempFilters((prev) => ({
                      ...prev,
                      otherMonth: value,
                      fromDate: null,
                      toDate: null
                    }));
                  }}
                  searchEnabled={true}
                  displayValue={(val) => val}
                  showAllOption={false}
                  hideAllOption={true}
                />
              )}

              {/* Other Quarter Filter - shows when "Other Quarter" is selected */}
              {selectedFilters.dateRange === "Other Quarter" && (
                <CommonFilter
                  label="Select Quarter"
                  options={getPastQuarterOptions(oldestSinceDT).map(option => ({
                    name: option.name,
                    ID: option.ID,
                  }))}
                  value={selectedFilters.otherQuarter}
                  onChange={(value) => {
                    setSelectedFilters((prev) => ({
                      ...prev,
                      otherQuarter: value,
                      fromDate: null,
                      toDate: null
                    }));
                    setTempFilters((prev) => ({
                      ...prev,
                      otherQuarter: value,
                      fromDate: null,
                      toDate: null
                    }));
                  }}
                  searchEnabled={true}
                  displayValue={(val) => val}
                  showAllOption={false}
                  hideAllOption={true}
                />
              )}

              {/* Other Year Filter - shows when "Other Year" is selected */}
              {selectedFilters.dateRange === "Other Year" && (
                <CommonFilter
                  label="Select Year"
                  options={getOtherYearOptions(oldestSinceDT).map(option => ({
                    name: option.name,
                    ID: option.ID,
                  }))}
                  value={selectedFilters.otherYear}
                  onChange={(value) => {
                    setSelectedFilters((prev) => ({
                      ...prev,
                      otherYear: value,
                      fromDate: null,
                      toDate: null
                    }));
                    setTempFilters((prev) => ({
                      ...prev,
                      otherYear: value,
                      fromDate: null,
                      toDate: null
                    }));
                  }}
                  searchEnabled={true}
                  displayValue={(val) => val}
                  showAllOption={false}
                  hideAllOption={true}
                />
              )}

              {/* Date Range Pickers - shows when a month is selected */}
              {(selectedFilters.dateRange === "Other Month" && selectedFilters.otherMonth !== "all") && (() => {
                const monthParts = selectedFilters.otherMonth.split(" ");
                const monthYear = monthParts.length === 2 ? `${monthParts[0]} ${monthParts[1]}` : null;
                const firstDay = monthParts.length === 2 ? new Date(`${monthParts[0]} 1, ${monthParts[1]}`) : null;
                const lastDay = monthParts.length === 2 ? (() => {
                  const date = new Date(`${monthParts[0]} 1, ${monthParts[1]}`);
                  date.setMonth(date.getMonth() + 1);
                  date.setDate(0);
                  return date;
                })() : null;

                return (
                  <div className={`flex items-center ${isMobile ? "mt-2" : ""} gap-2`}>
                    {/* <span className="text-sm font-medium text-text-color whitespace-nowrap">Date Range:</span> */}
                    <DatePicker
                      value={selectedFilters.fromDate || ""}
                      onChange={(date) => {
                        setSelectedFilters((prev) => ({ ...prev, fromDate: date }));
                        setTempFilters((prev) => ({ ...prev, fromDate: date }));
                      }}
                      placeholder="From"
                      disableFuture={false}
                      className="!space-y-0 !h-10 w-36"
                      minDate={firstDay?.toISOString().split('T')[0]}
                      maxDate={lastDay?.toISOString().split('T')[0]}
                      disableMonthNavigation={true}
                      disableYearNavigation={true}
                      defaultMonth={monthYear}
                      userIsAdmin={true}
                      useAsFilter={true}
                    />
                    <span className="text-text-color">to</span>
                    <DatePicker
                      value={selectedFilters.toDate || ""}
                      onChange={(date) => {
                        setSelectedFilters((prev) => ({ ...prev, toDate: date }));
                        setTempFilters((prev) => ({ ...prev, toDate: date }));
                      }}
                      placeholder="To"
                      disableFuture={false}
                      className="!space-y-0 !h-10 w-36"
                      minDate={firstDay?.toISOString().split('T')[0]}
                      maxDate={lastDay?.toISOString().split('T')[0]}
                      disableMonthNavigation={true}
                      disableYearNavigation={true}
                      defaultMonth={monthYear}
                      useAsFilter={true}
                    />
                  </div>
                );
              })()}

              {/* Date Range Pickers for This Month */}
              {selectedFilters.dateRange === "This Month" && (() => {
                const now = new Date();
                const currentMonth = now.getMonth();
                const currentYear = now.getFullYear();
                const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                const monthYear = `${months[currentMonth]} ${currentYear}`;
                const firstDay = new Date(currentYear, currentMonth, 1);
                const lastDay = new Date(currentYear, currentMonth + 1, 0);

                return (
                  <div className={`flex items-center ${isMobile ? "mt-2" : ""} gap-2`}>
                    {/* <span className="text-sm font-medium text-text-color whitespace-nowrap">Date Range:</span> */}
                    <DatePicker
                      value={selectedFilters.fromDate || ""}
                      onChange={(date) => {
                        setSelectedFilters((prev) => ({ ...prev, fromDate: date }));
                        setTempFilters((prev) => ({ ...prev, fromDate: date }));
                      }}
                      placeholder="From"
                      disableFuture={false}
                      className="!space-y-0 !h-10 w-36"
                      minDate={firstDay.toISOString().split('T')[0]}
                      maxDate={lastDay.toISOString().split('T')[0]}
                      disableMonthNavigation={true}
                      disableYearNavigation={true}
                      defaultMonth={monthYear}
                      useAsFilter={true}
                    />
                    <span className="text-text-color">to</span>
                    <DatePicker
                      value={selectedFilters.toDate || ""}
                      onChange={(date) => {
                        setSelectedFilters((prev) => ({ ...prev, toDate: date }));
                        setTempFilters((prev) => ({ ...prev, toDate: date }));
                      }}
                      placeholder="To"
                      disableFuture={false}
                      className="!space-y-0 !h-10 w-36"
                      minDate={firstDay.toISOString().split('T')[0]}
                      maxDate={lastDay.toISOString().split('T')[0]}
                      disableMonthNavigation={true}
                      disableYearNavigation={true}
                      defaultMonth={monthYear}
                      useAsFilter={true}
                    />
                  </div>
                );
              })()}

              {/* Star Filter */}
              <label className="flex items-center cursor-pointer select-none">
                <input
                  type="checkbox"
                  id="starFilterCheckbox"
                  checked={selectedFilters.starOnly}
                  onChange={(e) => {
                    setSelectedFilters((prev) => ({ ...prev, starOnly: e.target.checked }));
                  }}
                  className="mr-2 h-4 w-4 rounded border-gray-300 filter-border text-sahi-dark-blue focus:ring-sahi-dark-blue"
                />
                <span className="text-sm font-medium text-text-color whitespace-nowrap">
                  {isInqOnlyMode ? "Star Inquiries" : "Star Threads"}
                </span>
              </label>

              {/* Select Date Filter */}
              {/* <label className="flex items-center cursor-pointer select-none">
                <input
                  type="checkbox"
                  id="selectDateFilterCheckbox"
                  checked={selectedFilters.selectDate}
                  onChange={(e) => {
                    setSelectedFilters((prev) => ({ ...prev, selectDate: e.target.checked, selectedDate: e.target.checked ? prev.selectedDate : null }));
                    setTempFilters((prev) => ({ ...prev, selectDate: e.target.checked, selectedDate: e.target.checked ? prev.selectedDate : null }));
                  }}
                  className="mr-2 h-4 w-4 rounded border-gray-300 filter-border text-sahi-dark-blue focus:ring-sahi-dark-blue"
                />
                <span className="text-sm font-medium text-text-color whitespace-nowrap">Select Date</span>
              </label>

              {selectedFilters.selectDate && (
                <div className="flex items-center gap-2">
                  <DatePicker
                    value={selectedFilters.selectedDate || ""}
                    onChange={(date) => {
                      let dateStr = null;
                      if (date) {
                        const dateObj = new Date(date);
                        const year = dateObj.getFullYear();
                        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                        const day = String(dateObj.getDate()).padStart(2, '0');
                        dateStr = `${year}-${month}-${day}`;
                      }
                      setSelectedFilters((prev) => ({ ...prev, selectedDate: dateStr }));
                      setTempFilters((prev) => ({ ...prev, selectedDate: dateStr }));
                    }}
                    placeholder="Select date"
                    disableFuture={false}
                    className="!space-y-0 !h-10 w-40"
                  />
                </div>
              )} */}
              {/* <StageExpiryFilterDesktop /> */}
            </div>
          ))}

        {/*--------------- Data Section ------------*/}
        {isMobile ? (
          <div className="block lg:hidden">
            <div ref={parentRef} className="overflow-auto scrollbar-hide threads-virtualized-scrollbar">
              {(() => {
                const virtualItems = rowVirtualizer.getVirtualItems();
                if (loading || isLoading) {
                  return (
                    <div className="flex justify-center items-center w-full py-8">
                      <Loader2 className="h-6 w-6 animate-spin text-sahi-primary-color mr-2" />
                      <span className="text-text-color text-sm">Loading...</span>
                    </div>
                  );
                }
                return currentThreads.length > 0 ? (
                  <div
                    className="scrollbar-hide overflow-y-hidden space-y-2"
                  >
                    {(virtualItems.length > 0 ? virtualItems : currentThreads.map((_, i) => ({ index: i, measureElement: null }))).map((virtualRow) => {
                      const thread = currentThreads[virtualRow.index];
                      if (!thread) return null;
                      return (
                        <div
                          key={thread.threadID}
                          ref={virtualRow.measureElement}
                          onTouchStart={() => handleTouchStart(thread.threadID)}
                          onTouchEnd={handleTouchEnd}
                          onClick={() => handleMobileCardClick(thread)}
                        >
                          <MobileCard
                            thread={thread}
                            threadTypeInfo={threadTypeInfo}
                            threadTypes={threadTypes}
                            checked={thread.isChecked}
                            onCheckedChange={(val) => handleCheckboxChange(thread.threadID, val)}
                          />
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p className="no-records mb-3 lg:whitespace-nowrap">
                    <span>
                      {`No ${toAllWordsLowerCase(threadTypes[threadTypeInfo.typeID - 1]?.Typ ?? "threads")} ${hasActiveFilters ? 'found for selected filters.' : 'found.'}`}
                    </span>
                    {hasActiveFilters && (
                      <span
                        onClick={handleResetFilters}
                        className="ml-2 text-sahi-primary-color underline hover:text-sahi-primary-color/80 cursor-pointer inline-block"
                      > Clear filter.</span>
                    )}
                  </p>
                );
              })()}
            </div>
            {/* Add Button as Card */}
            {renderAddThreadButtonMobile()}
          </div>
        ) : (
          <WebDataTable />
        )}
        <ThreadEntry
          triggerButton={false}
          threadTypeID={selectedThreadTypeFromDropdown || 1} // Always fallback to 1 (default Inquiry), never 0
          open={threadEntryOpen}
          onOpenChange={(open) => {
            setThreadEntryOpen(open);
            if (!open) {
              setSelectedThreadTypeFromDropdown(null);
            }
          }}
          onThreadUpdated={() => {
            // Your existing refresh logic
          }}
        />

        {/* Reassign Dialog */}
        <ReassignDialog
          open={reassignDialogOpen}
          onOpenChange={setReassignDialogOpen}
          threadData={selectedThread}
          selectedThreadCount={threadDeleteBulkIDs.length}
          isBulkReassign={true}
          onReassign={(selectedUserID) => handleBulkReassign(selectedUserID, threadDeleteBulkIDs)}
        />

        {activeConnection && (
          <TemplateDialog
            isOpen={templateDialogOpen}
            onClose={() => {
              setTemplateDialogOpen(false);
              setActiveConnection(null);
            }}
            connectionData={activeConnection.connectionData}
            connID={activeConnection.connID}
            stageID={activeConnection.currStageID}
            onRecordAdded={null}
          />
        )}


        <BulkWhatsAppDialog
          isOpen={bulkWhatsAppDialogOpen}
          onClose={setBulkWhatsAppDialogOpen}
          threadData={selectedThreadsData}
          selectedThreadCount={threadDeleteBulkIDs.length}
          isBulkMessage={true}
        />

        {/* Thread details - Desktop only */}
        {!isMobile && (
          <ThrDetails
            isOpen={isThreadDetialsOpen}
            onClose={() => setIsThreadDetailsOpen(false)}
            threadID={selectedThread?.threadID}
            initialData={selectedThread}
          />
        )}

        {/* Integrations Dialog */}
        {userRights?.addThr && (
          <Integrations
            triggerButton={false}
            open={integrationsOpen}
            onOpenChange={setIntegrationsOpen}
          />
        )}

        <ConnectionDetails
          connID={selectedConnID}
          isOpen={isConnDetailOpen}
          onClose={() => setIsConnDetailOpen(false)}
          expandThreadID={selectedThread?.threadID}
        />

        <ConnectionDetailsMobile
          connID={selectedConnID}
          isOpen={isMobileConnDetailpOpen}
          onClose={() => setIsMobileConnDetailOpen(false)}
          expandThreadID={selectedThread?.threadID}
          isMobileContactActionsOpen={isMobileContactActionsOpen}
          onCloseContactActions={() => setIsMobileContactActionsOpen(false)}
        />

      </div>
    </TooltipProvider >
  );
};

export default Threads;

